import React, {Component} from 'react';
import dayjs from 'dayjs';
import Cookies from 'js-cookie';
import * as _ from 'lodash-es';
import parse from 'html-react-parser';
import {MapTo} from '@adobe/aem-react-editable-components';
import * as axios from 'axios';
import utc from 'dayjs/plugin/utc';

import SubscriptionSelection from './components/SubscriptionSelection';
import PaymentOptionAssets from './components/PaymentOptionAssets';
import CoreLicense from './components/CoreLicense';
import DataService from './DataService.js';
import CoreLicenseDropdown from './components/CoreLicenseDropdown';
import {isVatActive, isVatUndefined} from '../../utils/ecommerce/vat.js';
import SubscriptionSelectionRequiredMessage from './components/SubscriptionSelectionRequiredMessage';
import SubscriptionLimitMessage from './components/SubscriptionLimitMessage';
import ValidationError from './components/ValidationError';
import CartValidationErrorMessage from './components/CartValidationErrorMessage';
import {cartType, getItemPrices} from '../../utils/ecommerce/cart.js';
import {formatStorePrice as _formatStorePrice} from '../../utils/ecommerce/currency.js';
import CartMessageBar from './components/CartMessageBar';
import {Analytics} from '../../utils/common/analytics';
import {getRootDomain} from '../../utils/common/url';
import {announce} from '../../utils/common/live-announcer';
import {intersectionBy, sumBy} from '../../utils/common/array';
import HostingRegionPicker from './components/HostingRegionPicker.js';
import CalciteLoader from '../shared/CalciteLoader.js';
import CalciteScrim from '../shared/CalciteScrim.js';
dayjs.extend(utc);

const US_REGION = 'United States';
class Cart extends Component {
  constructor(props) {
    super(props);
    this.products;
    this.cart = null;
    this.shareCart = null;
    this.showAutoRenewableInfo = false;
    this.cartSubtotalPrice = 0;
    this.language;
    this.proceedToCheckoutError = false;
    this.paymentOptionAssetsData = [];
    this.isOrgDesktopColumnHidden = true;
    this.autoRenewalSwitchesEl = [];
    this.autoRenewalAlerts = [];
    this.isDiscountAppliedHidden = true;
    this.shareCartAlert = React.createRef();
    this.distributorName = null;
    this.distPrintCart = null;
    this.analytics = Analytics.getInstance();
    this.activeHostingRegion = null;
    this.hostingRegions = [];

    this.onQuantityChange = this.onQuantityChange.bind(this);
    this.removeItem = this.removeItem.bind(this);
    this.proceedToCheckout = this.proceedToCheckout.bind(this);
    this.showHideModal = this.showHideModal.bind(this);
    this.goToCustomerNumberPage = this.goToCustomerNumberPage.bind(this);
    this.onAutoRenewalFlagChange = this.onAutoRenewalFlagChange.bind(this);
    this.assignCoreLicenses = this.assignCoreLicenses.bind(this);
    this.handleShareCartClick = this.handleShareCartClick.bind(this);
    this.handleShareCartAlertClose = this.handleShareCartAlertClose.bind(this);
    this.handlePrintCartClick = this.handlePrintCartClick.bind(this);
    this.addPrintCartStyle = this.addPrintCartStyle.bind(this);

    this.localizedKeys = {
      shoppingCartTitle: this.props.cartTitle,
      orgLabel: this.props.orgLabel,
      shoppingForLabel: this.props.shoppingForLabel,
      productLabel: this.props.productLabel,
      priceLabel: this.props.priceLabel,
      quantityLabel: this.props.quantityLabel,
      amountLabel: this.props.amountLabel,
      removeLabel: this.props.removeLabel,
      lineItemTotalLabel: this.props.itemTotalLabel,
      selectOrgLabel: this.props.selectOrgLabel,
      expireLabel: this.props.expireLabel,
      continueCheckoutLabel: this.props.continueCheckoutLabel,
      callExpertNeedHelpLabel: this.props.callExpertNeedHelpLabel,
      callExpertNotSureText: this.props.callExpertNotSureText,
      callExpertTalkText: this.props.callExpertTalkText,
      renewOrgLabel: this.props.renewOrgLabel,
      existingOrgLabel: this.props.existingOrgLabel,
      convertTrialOrgLabel: this.props.convertTrialOrgLabel,
      newOrgLabel: this.props.newOrgLabel,
      newOrgTitle: this.props.newOrgTitle,
      newOrgConfirmHeading: this.props.newOrgConfirmHeading,
      newOrgConfirmMessage: this.props.newOrgConfirmMessage,
      newOrgConfirmLabel: this.props.newOrgConfirmLabel,
      arcgisOnlineLabel: this.props.arcgisOnlineLabel,
      customerNumberLabel: this.props.customerNumberLabel,
      discountAppliedLabel: this.props.discountAppliedLabel,
      continueShoppingLabel: this.props.continueShoppingLabel,
      continueLabel: this.props.continueLabel,
      autoRenewLabel: this.props.autoRenewLabel,
      assignCoreLicensesLabel: this.props.assignCoreLicensesLabel,
      editCoreLicensesLabel: this.props.editCoreLicensesLabel,
      coreLicensesSelectionTitleLabel:
        this.props.coreLicensesSelectionTitleLabel,
      totalLicenseAssignedLabel: this.props.totalLicenseAssignedLabel,
      totalLicenseunAssignedLabel: this.props.totalLicenseunAssignedLabel,
      newCoreLicensesTitleLabel: this.props.newCoreLicensesTitleLabel,
      existingCoreLicensesTitleLabel: this.props.existingCoreLicensesTitleLabel,
      coreLicensesLabel: this.props.coreLicensesLabel,
      licenseQuantityLabel: this.props.licenseQuantityLabel,
      subTotalLabel: this.props.subTotalLabel,
      currentlyInCartLabel: this.props.currentlyInCartLabel,
      subscriptionIdLabel: this.props.subscriptionIdLabel,
      clearLabel: this.props.clearLabel,
      availableLicensesLabel: this.props.availableLicensesLabel,
      cancelLabel: this.props.cancelLabel,
      saveAssignmentLabel: this.props.saveAssignmentLabel,
      coreLicensesAssignmentLabel: this.props.coreLicensesAssignmentLabel,
      licensesAssignedLabel: this.props.licensesAssignedLabel,
      cartProratedPricingDescription: this.props.cartProratedPricingDescription,
      cartMoneyBackGuaranteeMessage: this.props.cartMoneyBackGuaranteeMessage,
      cartPricingFootnote: this.props.cartPricingFootnote,
      cartEmptyMessage: this.props.cartEmptyMessage,
      extensionSplitLineitemMessage: this.props.extensionNewLineitemMessage,
      subscriptionSelectionRequiredMessage:
        this.props.subscriptionSelectionRequiredMessage,
      cartValidationErrorTitle: this.props.cartValidationErrorTitle,
      cartValidationErrorMessage: this.props.cartValidationErrorMessage,
      cartValidationModalErrorTitle: this.props.cartValidationModalErrorTitle,
      cartValidationModalErrorMessage:
        this.props.cartValidationModalErrorMessage,
      subscriptionLimitMessage: this.props.subscriptionLimitMessage,
      errorMessage2Title: this.props.errorMessageTwoTitle,
      errorMessage2: this.props.errorMessageTwo,
      errorMessage3Title: this.props.errorMessageThreeTitle,
      errorMessage3: this.props.errorMessageThree,
      errorMessage4Title: this.props.errorMessageFourTitle,
      errorMessage4: this.props.errorMessageFour,
      errorMessage5Title: this.props.errorMessage5Title,
      errorMessage5: this.props.errorMessage5,
      errorMessage6Title: this.props.errorMessage6Title,
      errorMessage6: this.props.errorMessage6,
      errorMessage9Title: this.props.errorMessageNineTitle,
      errorMessage9: this.props.errorMessageNine,
      errorMessage8Title: this.props.errorMessage8Title,
      errorMessage8: this.props.errorMessage8,
      errorMessage10Title: this.props.errorMessage10Title,
      errorMessage10: this.props.errorMessage10,
      cartLoadingMessageGeneric: this.props.cartLoadingMessageGeneric,
      coreLicensesHeaderMessage: this.props.coreLicensesHeaderMessage,
      coreLicensesAvailableMessage: this.props.coreLicensesAvailableMessage,
      cartLoadingMessage1: this.props.cartLoadingMessage1,
      cartLoadingMessage2: this.props.cartLoadingMessage2,
      cartLoadingMessage3: this.props.cartLoadingMessage3,
      cartLoadingMessageInterval: this.props.cartLoadingMessageInterval,
      purchaseOrderLabel: this.props.purchaseOrderLabel,
      authorizationToInvoiceLabel: this.props.authorizationToInvoiceLabel,
      vatIncludedLabel: this.props.vatIncludedLabel,
      vatExcludedLabel: this.props.vatExcludedLabel,
      autoRenewalAlertTitle: this.props.autoRenewalAlertTitle,
      autoRenewalAlertMessage: this.props.autoRenewalAlertMessage,
      shareCartLabel: this.props.shareCartLabel,
      printCartLabel: this.props.printCartLabel,
      shareCartAlertTitle: this.props.shareCartAlertTitle,
      shareCartAlertMessage: this.props.shareCartAlertMessage,
      fromSalesRepLabel: this.props.fromSalesRepLabel,
      quoteDisclaimerMessage: this.props.quoteDisclaimerMessage,
      hostingRegionLabel: this.props.hostingRegionLabel,
      hostingRegionSelectHeading: this.props.hostingRegionSelectHeading,
      hostingRegionInfoContent: this.props.hostingRegionInfoContent,
      hostingRegionSelectWarningMessage:
        this.props.hostingRegionSelectWarningMessage,
      hostingRegionUnitedStatesOptionLabel:
        this.props.hostingRegionUnitedStatesOptionLabel,
      hostingRegionEuropeOptionLabel: this.props.hostingRegionEuropeOptionLabel,
      hostingRegionAsiaPacificOptionLabel:
        this.props.hostingRegionAsiaPacificOptionLabel,
      newLabel: this.props.newLabel,
      changeLabel: this.props.changeLabel,
    };
    this.vatMessage = this.getVatMessage();

    this.urls = {
      contactUsPageUrl: this.props.contactUsPageUrl,
      storeHomePageUrl: this.props.storeHomePageUrl,
    };

    const urlParams = new URLSearchParams(window.location.search);

    this.state = {
      isLoaded: false,
      token: this.getJSONCookie('esri_auth')
        ? this.getJSONCookie('esri_auth').token
        : null,
      proceedToCheckout: false,
      cartError: false,
      isLoginRedirect: urlParams && urlParams.has('signin'),
      cartId: this.getCookie('eCommCartId'),
      isCartEmpty: false,
      checkoutModal: 'hidden',
      proceedToCheckoutClickedOnce: false,
      storeDomain:
        window.location.hostname.indexOf('local') > -1
          ? 'https://uat.esri.com'
          : window.location.origin,
      onQuantityChange: false,
      cartLoadingMessage: this.localizedKeys.cartLoadingMessageGeneric,
      userLocale:
        document.documentElement.lang
        && document.documentElement.lang.indexOf('-') > -1
          ? document.documentElement.lang
          : 'en-us',
      isShareCartAlertActive: false,
      isShareCartDisabled: false,
      isShareCartHidden:
        !this.localizedKeys.shareCartLabel
        || !this.localizedKeys.shareCartAlertTitle
        || !this.localizedKeys.shareCartAlertMessage,
    };
  }

  async componentDidMount() {
    this.setEnvUrls();

    // Setup new cart from share link
    await this.setupCartFromShareLink();

    // Check if user is logged in.
    if (this.state.token) {
      await this.setShoppingCart();
    } else if (this.state.cartId) {
      try {
        // check if there is a cartId cookie
        await this.getCart();
      } catch (e) {
        this.analytics.addEvent(Analytics.eventType.ERROR, {
          errorDesc: `${e?.name}: ${e?.message}`,
        });
      }
    } else {
      this.setState({isLoaded: true, isCartEmpty: true});
    }

    if (this.cart && this.cart.lineItems && this.cart.lineItems.length > 0) {
      this.origCart = JSON.parse(JSON.stringify(this.cart));
      // Add event listener to the autorenewal calcite switch.
      this.autoRenewalSwitchesEl.map((el, index) => {
        el.addEventListener('calciteSwitchChange', (event) => {
          this.autoRenewalAlerts = [];
          const cartItem = this.cart.lineItems[index];
          const checked = event?.detail?.switched || event.target.checked;
          this.onAutoRenewalFlagChange(cartItem, checked, index);
        });
      });
    }

    if (this.shareCartAlert.current) {
      this.shareCartAlert.current.addEventListener(
        'calciteAlertClose',
        this.handleShareCartAlertClose,
      );
      // move to body to create a stacking context
      document.body.appendChild(this.shareCartAlert.current);
    }
    this.addPrintCartStyle();
    this.analytics.addPageInfo({
      pageType: 'cart',
      ecommerce: {
        storeType: Analytics.storeType.OMNI,
        storeFront: Analytics.toStoreFront(
          this.cart?.zone || this.getCookie('selectedZone'),
        ),
        distributorNumber: this.cart?.distributorNumber,
      },
    });
    this.analytics.addEvent(Analytics.eventType.CART_VIEW, {
      ...(this.cart && {cartID: this.cart._id}),
      items: Analytics.toItems([this.cart], Analytics.dataType.CART),
    });
  }

  componentWillUnmount() {
    if (this.shareCartAlert.current) {
      this.shareCartAlert.current.removeEventListener(
        'calciteAlertClose',
        this.handleShareCartAlertClose,
      );
    }
  }

  async setupCartFromShareLink() {
    const shareId = this.getShareId();
    if (!shareId) return;

    // Remove previous cart id from cookies to prevent global nav from fetching it
    const previousCartId = this.getCookie('eCommCartId');
    this.removeCookie('eCommCartId');

    // Remove share-id query param
    const url = new URL(window.location.href);
    url.searchParams.delete('share-id');
    window.history.replaceState({}, document.title, url.href);

    // Create build and share cart instance
    const newCart = await DataService.createBuildAndShareCartInstance(
      this.urls.istApiUrl,
      shareId,
    );
    if (!newCart?._id) {
      this.setCookie('eCommCartId', previousCartId);
      return;
    }

    const totalQty
      = newCart.lineItems?.reduce(
        (acc, item) => acc + (item?.quantity || 0),
        0,
      ) || 0;
    this.setGlobalNavCartQuantity(totalQty);
    this.setCookie('eCommCartId', newCart._id);
    this.setState({cartId: newCart._id});
  }

  // Data service calls
  async setShoppingCart() {
    try {
      let cartLoadingMessageCount = 0;
      const cartLoadingMessageInterval
        = Number(this.props.cartLoadingMessageInterval) * 1000 || 2000;

      // Fake cart loading message at a certain internal.
      const setLoadingCartMessages = setInterval(() => {
        if (
          this.localizedKeys[
            'cartLoadingMessage' + (cartLoadingMessageCount + 1)
          ]
        ) {
          this.setState({
            cartLoadingMessage:
              this.localizedKeys[
                'cartLoadingMessage' + (cartLoadingMessageCount + 1)
              ],
          });
        } else {
          this.setState({
            cartLoadingMessage: this.localizedKeys.cartLoadingMessageGeneric,
          });
        }

        cartLoadingMessageCount++;
      }, cartLoadingMessageInterval);

      let cartParams;

      // check if cart id exists otherwise pull the latest cart with status 'new'
      if (this.state.cartId) {
        cartParams = {
          cartId: this.state.cartId,
          userLocale: this.state.userLocale,
          storeDomain: this.state.storeDomain,
        };
      } else {
        cartParams = {
          latest: true,
          userLocale: this.state.userLocale,
          storeDomain: this.state.storeDomain,
        };
      }

      const shoppingCartResponse = await DataService.processShoppingCart(
        this.urls.istApiUrl,
        cartParams,
      );
      this.cart = shoppingCartResponse.cart;
      this.processReferralId(this.cart);
      this.updateCartPurchaseEligible();

      if (this.isAutoRenewalHiddenLocale(this.cart?.metadata?.storeDomain)) {
        this.updateItemsDefaultIsAuto();
      }
      if (shoppingCartResponse && shoppingCartResponse.redirectUri) {
        if (window.location.href.includes('int-store') && this.cart.zone) {
          this.setCookie('selectedZone', this.cart.zone);
        }
        window.location.href = shoppingCartResponse.redirectUri;
      }

      if (this.cart && this.cart.zone && !this.getCookie('eCommCartId')) {
        this.setCookie('eCommCartId');
      } else if (!this.cart) {
        this.removeCookie('eCommCartId'); // The cartId maybe associated with another user, hence the cartId needs to be deleted.
      }

      clearInterval(setLoadingCartMessages);

      if (this.cart && this.cart.lineItems && this.cart.lineItems.length > 0) {
        if (
          !this.cart.metadata.customer
          || !this.cart.metadata.customer.customerNumber
        ) {
          this.goToCustomerNumberPage();
        } else {
          this.setAdobeDataLayer('Omni Cart View');

          await this.setPaymentOptionAsset();

          this.setSelectSubscriptionRequired();
          this.updateItemsHostingRegion();
          this.cart.lineItems.map((item) => {
            this.checkMaxQtyAllowRules(item, item.quantity);
            this.updateCartItem(item, item.quantity);
          });
          this.updateCartMetadata();
          DataService.updateCart(this.urls.istApiUrl, this.cart);
          return this.renderProducts();
        }
      } else {
        this.setState({isLoaded: true, isCartEmpty: true});
      }
    } catch (e) {
      this.analytics.addEvent(Analytics.eventType.ERROR, {
        errorDesc: `${e?.name}: ${e?.message}`,
      });
      this.setState({isLoaded: true, cartError: true});
    }
  }

  async setPaymentOptionAsset() {
    if (this.cart && this.cart.zone) {
      const localeResponse = await DataService.locale(
        this.urls.istApiUrl,
        null,
        this.cart.zone,
      );
      this.distPrintCart = localeResponse.distPrintCart;
      this.distributorName = localeResponse.distributorName;
      this.paymentOptionAssetsData
        = localeResponse.paymentConfig
          && localeResponse.paymentConfig.paymentOptionAssets
          ? localeResponse.paymentConfig.paymentOptionAssets
          : [];
      this.hostingRegions = this.getHostingRegions(
        localeResponse?.regionalHosting,
        this.localizedKeys,
      );
      this.activeHostingRegion = this.getActiveHostingRegion(
        localeResponse?.regionalHosting,
        this.hostingRegions,
        this.cart,
      );
    }
  }

  async getCart() {
    try {
      this.cart = await DataService.getCart(
        this.urls.istApiUrl,
        this.state.cartId,
      );
      this.processReferralId(this.cart);
      await this.setPaymentOptionAsset();

      const isCartEmpty
        = !this.cart || !this.cart.lineItems || this.cart.lineItems.length === 0;
      const pricingRequest = [];

      if (!this.cart) {
        this.removeCookie('eCommCartId'); // The cartId maybe associated with another user, hence the cartId needs to be deleted.
      }

      if (!isCartEmpty) {
        const validateRenewalConfigRequest = {
          zone: this.cart.zone,
          countryCode: '',
          region: '',
          lineItems: [],
        };

        _.forEach(this.cart.lineItems, (item) => {
          this.resetSubscrptionDates(item);
          pricingRequest.push({
            lineItemId: item._id,
            productIdentifierType: 'productId',
            productIdentifierValue: item.materialNumber.toString(),
            quantity: item.quantity,
            startDate: item.startDate,
            endDate: item.endDate,
          });

          validateRenewalConfigRequest.lineItems.push({
            id: item._id,
            sku: item.materialNumber.toString(),
            name: item.productName,
          });
        });

        const [pricingResponse, renewalConfigResponse] = await axios.all([
          DataService.getPrice(
            this.urls.istApiUrl,
            pricingRequest,
            this.cart.zone,
            this.cart.currency,
            this.cart.distributorNumber,
          ),
          DataService.validateRenewalConfig(
            this.urls.istApiUrl,
            validateRenewalConfigRequest,
          ),
        ]);

        this.cart.lineItems.map((item) => {
          const pricingItem = _.find(pricingResponse, {
            lineItemId: item._id,
          });

          if (pricingItem && pricingItem.isPurchasable) {
            item.metadata.maxQtyAllowed = parseInt(pricingItem.maxQtyAllowed);
            item.metadata.pricing = {
              itemTotalPrice: pricingItem.quantityOnePrice * item.quantity,
              listPrice: parseInt(pricingItem.listPrice),
              vatListPrice: parseInt(pricingItem.vatListPrice),
              quantityOnePrice: parseInt(
                pricingItem.quantityOnePrice || pricingItem.listPrice,
              ),
              pricingTiers: pricingItem.pricingTiers,
            };
            item.metadata.errorCode = 0;
          } else {
            item.metadata.errorCode = 9;
          }

          this.setAutoRenewalProducts(item, renewalConfigResponse);

          if (item.metadata.productInfo.autoRenewal) {
            item.metadata.isAuto = item.metadata.isAuto || false;
          }

          this.checkMaxQtyAllowRules(item, item.quantity);
          this.updateCartItem(item, item.quantity);
        });

        if (this.isAutoRenewalHiddenLocale(this.cart?.metadata?.storeDomain)) {
          this.updateItemsDefaultIsAuto();
        }

        this.updateCartMetadata();
        DataService.updateCart(this.urls.istApiUrl, this.cart);

        this.language = this.cart.locale.split('-')[0];
        this.checkIfCartValid();
        this.renderProducts();

        this.setAdobeDataLayer('Omni Cart View');
      } else {
        this.setState({isLoaded: true, isCartEmpty: true});
      }
    } catch (e) {
      this.analytics.addEvent(Analytics.eventType.ERROR, {
        errorDesc: `${e?.name}: ${e?.message}`,
      });
      this.setState({isLoaded: true, cartError: true});
    }
  }

  async localeRedirection() {
    const localeRedirectionResponse = await DataService.localeRedirection(
      this.urls.istApiUrl,
      window.location.href,
    );

    if (localeRedirectionResponse && localeRedirectionResponse.isRedirect) {
      if (
        localeRedirectionResponse.cookies
        && localeRedirectionResponse.cookies.length > 0
      ) {
        localeRedirectionResponse.cookies.forEach((cookie) => {
          document.cookie = `${cookie.name}=${cookie.value};secure;${cookie.expires};path=${cookie.path};domain=${cookie.domain};`;
        });
      }

      if (
        localeRedirectionResponse.localStorage
        && localeRedirectionResponse.localStorage.length > 0
      ) {
        localeRedirectionResponse.localStorage.forEach((item) => {
          localStorage.setItem(item.id, item.value);
        });
      }

      window.location.href = localeRedirectionResponse.redirect_uri;

      return true;
    } else {
      return false;
    }
  }

  resetSubscrptionDates(item) {
    if (!item) return;

    const now = dayjs();
    item.startDate = now.format('YYYY-MM-DD') + 'T00:00:00Z';
    item.endDate
      = now.add(1, 'years').subtract(1, 'days').format('YYYY-MM-DD')
        + 'T00:00:00Z';
  }

  getShareId() {
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });
    if (!params['share-id']) return null;

    return params['share-id'];
  }

  serializeLineItems(lineItems) {
    const items = _.cloneDeep(lineItems || []);
    items.forEach((item) => {
      if (!item?.metadata) return;

      delete item.metadata.pricing;
      delete item.metadata.subscriptions;
    });

    return window.btoa(JSON.stringify(items));
  }

  deserializeLineItems(serializedLineItems) {
    try {
      return JSON.parse(window.atob(serializedLineItems));
    } catch (err) {
      return [];
    }
  }

  isAutoRenewalHiddenLocale(storeDomain) {
    if (!storeDomain) return false;

    const hiddenLocales = ['nl-nl']; // add or remove locations where autorenewal should be hidden
    const isHiddenLocale = hiddenLocales.some((locale) =>
      storeDomain?.includes(locale),
    );

    return isHiddenLocale;
  }

  isAutoRenewalHidden(cart) {
    if (!cart?.metadata) return true;

    const storeDomain = cart.metadata.storeDomain;
    const isHiddenLocale = this.isAutoRenewalHiddenLocale(storeDomain);
    const showAutoRenewalHeader = cart.metadata.showAutoRenewalHeader;
    return isHiddenLocale || !showAutoRenewalHeader;
  }

  updateItemsDefaultIsAuto() {
    if (!this.cart?.lineItems.length) return;

    this.cart.lineItems.forEach((lineItem) => {
      const autoRenewal = lineItem?.metadata?.productInfo?.autoRenewal;
      if (!autoRenewal) return;

      lineItem.metadata.isAuto = autoRenewal;
    });
  }

  getVatMessage() {
    const VAT_INCLUDED = this.localizedKeys.vatIncludedLabel;
    const VAT_EXCLUDED = this.localizedKeys.vatExcludedLabel;
    if (isVatUndefined()) return '';

    return isVatActive() ? VAT_INCLUDED : VAT_EXCLUDED;
  }

  /**
   * Retrieves the hosting regions based on the provided regional hosting and localized keys.
   *
   * @param {Object} regionalHosting - The regional hosting object.
   * @param {Object} localizedKeys - The localized keys object.
   * @returns {Array} An array of hosting regions with their corresponding values and names.
   */
  getHostingRegions(regionalHosting, localizedKeys) {
    const hostingRegionsVal = regionalHosting?.rhOptional || [];
    const defaultRegion = regionalHosting?.rhDefault;

    if (defaultRegion && !hostingRegionsVal.includes(defaultRegion)) {
      hostingRegionsVal.unshift(defaultRegion);
    }

    return hostingRegionsVal.map((region) => ({
      value: region,
      // i.e. hostingRegionUnitedStatesOptionLabel
      name:
        localizedKeys[`hostingRegion${region.replace(/\s/g, '')}OptionLabel`]
        || region,
    }));
  }

  /**
   * Retrieves the active hosting region based on the provided parameters.
   *
   * @param {Object} regionalHosting - The regional hosting object.
   * @param {Array} hostingRegions - The array of available hosting regions.
   * @param {Object} cart - The cart object containing line items.
   * @returns {string|null} - The active hosting region or null if not found.
   */
  getActiveHostingRegion(regionalHosting, hostingRegions, cart) {
    let previousHostingRegion = null;
    const hostingRegionsVal = hostingRegions.map((region) => region.value);
    for (let i = 0; i < cart.lineItems.length; i++) {
      const item = cart.lineItems[i];
      if (
        item.metadata.hostingRegion
        && hostingRegionsVal.includes(item.metadata.hostingRegion)
      ) {
        previousHostingRegion = item.metadata.hostingRegion;
        if (!this.isDefaultRegionUS(item)) {
          break;
        }
      }
    }

    return (
      previousHostingRegion
      || regionalHosting?.rhDefault
      || (hostingRegionsVal.length && hostingRegionsVal[0])
      || null
    );
  }

  /**
   * Checks if the given item belongs to the default region (US).
   * @param {Object} item - The item to check.
   * @returns {boolean} - Returns true if the item belongs to the default region, false otherwise.
   */
  isDefaultRegionUS(item) {
    return !item?.metadata?.regionalHostingEligible;
  }

  /**
   * Checks if hosting region is required for the given item.
   * @param {Object} item - The item to check.
   * @returns {boolean} - Returns true if hosting region is required, false otherwise.
   */
  isHostingRegionRequired(item) {
    if (!item || !item.metadata) return false;

    return (
      item.metadata.subscriptions?.selectorType === 'subscriptionSelector'
      && item.metadata.subscriptionType === 'new'
    );
  }

  /**
   * Updates the hosting region for each item in the cart based on certain conditions.
   * If the item requires a hosting region, it sets the hosting region to either the default US region or the active hosting region.
   * If the item does not require a hosting region, it removes the hosting region metadata.
   */
  updateItemsHostingRegion = () => {
    if (!this.cart || !this.cart.lineItems) return;

    this.cart.lineItems.forEach((item) => {
      if (!item.metadata) return;

      if (this.isHostingRegionRequired(item)) {
        const region = this.isDefaultRegionUS(item)
          ? US_REGION
          : this.activeHostingRegion;
        item.metadata.hostingRegion = region;
      } else {
        delete item.metadata.hostingRegion;
      }
    });
  };

  /**
   * Handles the change of the hosting region.
   *
   * @param {string} selectedHostingRegion - The selected hosting region.
   * @returns {void}
   */
  handleHostingRegionChange = (selectedHostingRegion) => {
    this.activeHostingRegion = this.hostingRegions.find(
      (region) => region.value === selectedHostingRegion,
    )?.value;
    this.updateItemsHostingRegion();
    DataService.updateCart(this.urls.istApiUrl, this.cart);
    this.renderProducts();
  };

  processReferralId(cart) {
    if (!cart?.metadata) return;

    const sfId = this.getCookie('sf_id');
    const epnId = this.getCookie('epn_id');
    if (sfId || epnId) {
      cart.metadata.sfReferenceId = sfId || epnId;
    }
  }

  // Render functions
  render() {
    if (!this.state.isLoaded) {
      return (
        <CalciteLoader
          text={this.state.cartLoadingMessage}
          label={this.state.cartLoadingMessage}
          type="indeterminate"
        />
      );
    } else if (this.state.isLoaded && this.state.cartError) {
      return (
        <CartValidationErrorMessage
          errorTitle={this.localizedKeys.cartValidationErrorTitle}
          errorMessage={this.localizedKeys.cartValidationErrorMessage}
        />
      );
    } else if (this.state.isLoaded && this.state.isCartEmpty) {
      return (
        <div className="grid-container padding-leader-2 padding-trailer-2">
          <div className="shoppingCart empty">
            <header>
              <h2 className="font-size-4 avenir-regular text-off-black">
                {' '}
                {this.localizedKeys.shoppingCartTitle}{' '}
              </h2>
            </header>
            <h3 className="font-size-6 avenir-regular">
              <div className="richtext-container">
                {this.localizedKeys.cartEmptyMessage
                && parse(this.localizedKeys.cartEmptyMessage)}
              </div>
            </h3>
            <calcite-button
              class="trailer-half cart-cta"
              href={this.urls.storeHomePageUrl}
              scale="l"
            >
              <div className="button-slotted-content">
                <span className="button-slotted-content__text">
                  {this.localizedKeys.continueShoppingLabel}
                </span>
                <calcite-icon
                  class="button-slotted-content__icon margin-left--4 flip-rtl"
                  scale="s"
                  icon="arrow-right"
                ></calcite-icon>
              </div>
            </calcite-button>
            {this.renderCartContactUs(
              this.localizedKeys.callExpertNeedHelpLabel,
            )}
            <div className="quoteDisclaimerMessage">
              <div className="richtext-container">
                {this.localizedKeys.quoteDisclaimerMessage
                && parse(this.localizedKeys.quoteDisclaimerMessage)}
              </div>
            </div>

            {/* <calcite-button scale="xl" icon={arrowRight24F} icon-position="end" href="https://store.esri.com">
              {this.localizedKeys.continueShoppingLabel}
            </calcite-button>
            <p className="font-size--1 text-darkest-gray"> {this.localizedKeys.callExpertNeedHelpLabel}
              <calcite-button appearance="transparent" href="#">
                {this.localizedKeys.callExpertTalkText}
              </calcite-button>
            </p> */}
          </div>
        </div>
      );
    } else {
      return this.renderShoppingCart();
    }
  }

  renderShoppingCart() {
    return (
      <div className="cart-wrapper">
        {this.state.proceedToCheckout && (
          <CalciteScrim>
            <CalciteLoader
              text={this.state.cartLoadingMessage}
              label={this.state.cartLoadingMessage}
              type="indeterminate"
            />
          </CalciteScrim>
        )}
        <div data-distributor-number={this.cart.distributorNumber}> </div>
        <div data-store-type="Omni Store"> </div>

        {/*  Modal on cart error/messaging */}
        <div
          id="cartValidationErrorModal"
          className="opacityLayer"
          data-attribute="hidden"
        ></div>
        <div
          id="cartValidationErrorMessage"
          className="mainErrorMessage"
          data-attribute="hidden"
        >
          <h2 className="avenir-regular font-size-4 text-off-black">
            {' '}
            {this.localizedKeys.cartValidationModalErrorTitle}{' '}
          </h2>
          <div className="avenir-regular font-size-1 text-off-black padding-trailer-1">
            <div className="richtext-container">
              {this.localizedKeys.cartValidationModalErrorMessage
              && parse(this.localizedKeys.cartValidationModalErrorMessage)}
            </div>
          </div>
          <calcite-button
            scale="m"
            onClick={() =>
              this.showHideModal(
                '#cartValidationErrorModal',
                '#cartValidationErrorMessage',
                'hide',
              )
            }
          >
            <div className="button-slotted-content">
              <span className="button-slotted-content__text">
                {this.localizedKeys.continueLabel}
              </span>
              <calcite-icon
                class="button-slotted-content__icon margin-left--4 flip-rtl"
                scale="s"
                icon="arrow-right"
              ></calcite-icon>
            </div>
          </calcite-button>
        </div>
        <div>
          <div
            id="coreLicenseSelectionModal"
            className="opacityLayer"
            data-attribute="hidden"
          ></div>
          <div
            id="coreLicenseSelectionModalContent"
            className="mainErrorMessage configModal modalsection"
            data-attribute="hidden"
          >
            <div className="configModal-header">
              <h2 className="avenir-regular font-size-2 trailer-0 text-off-black">
                {' '}
                {this.localizedKeys.coreLicensesSelectionTitleLabel}{' '}
              </h2>
              <button
                className="configModal-close"
                onClick={() => this.onAssignCoreLicenses()}
              ></button>
            </div>
            <div className="configModal-content">
              {this.state.coreLicenses
              && this.state.coreLicenses.length > 0 && (
                <CoreLicense
                  onAssignCoreLicenses={(updateLineItem) => {
                    this.onAssignCoreLicenses(updateLineItem);
                  }}
                  coreLicenses={this.state.coreLicenses}
                  currency={this.cart.metadata.currency}
                  formattedLocale={this.cart.metadata.formattedLocale}
                  lineItem={this.state.coreLicensesLineItem}
                  localizedKeys={this.localizedKeys}
                  proceedToCheckoutError={this.proceedToCheckoutError}
                />
              )}
            </div>
          </div>
        </div>

        {/*  <calcite-modal aria-labelledby="modal-title" color="red" class="cartErrorModal">
          <h3 slot="header" id="modal-title"> {this.localizedKeys.cartValidationModalErrorTitle} </h3>
          <div slot="content">
            {this.localizedKeys.cartValidationModalErrorMessage}
          </div>
          <calcite-button slot="primary" width="full" scale="s" has-text={true}
            icon={arrowRight24F} iconposition="end" onClick={() => this.toggleCartErrorModal('close')} >
            {this.localizedKeys.continueLabel}
          </calcite-button>
        </calcite-modal> */}

        <div className="shoppingCart-mobileNav">
          <div>
            <h2 className="font-size-2 esri-font-medium shoppingCart-mobileNav-title">
              {this.localizedKeys.shoppingCartTitle}
            </h2>
          </div>
          {this.renderCheckoutButtons(true)}
        </div>

        <h1 className="font-size-4 esri-font-demi shoppingCart-title">
          {this.localizedKeys.shoppingCartTitle}
        </h1>

        {/* Display cart message bar */}
        {((this.state.token && this.cart.metadata?.customer?.customerNumber)
          || this.cart.metadata?.salesNotes) && (
          <CartMessageBar
            cart={this.cart}
            token={this.state.token}
            localizedKeys={this.localizedKeys}
            onCustomerNumberClick={this.goToCustomerNumberPage}
          />
        )}
        <div className={`shoppingCart`}>
          {this.cart.metadata.validateCart
          && this.cart.metadata.validateCart.exceedSubscriptionLimit && (
            <SubscriptionLimitMessage
              content={this.localizedKeys.subscriptionLimitMessage}
            />
          )}

          <table
            className={`cart-table ${
              this.isOrgDesktopColumnHidden
                ? 'cart-table--organization-hidden'
                : ''
            } ${
              !this.showAutoRenewableInfo ? 'cart-table--autorenew-hidden' : ''
            }`}
          >
            <thead>
              <tr className="cart-table__row cart-table__row--headers ui-text-2">
                <th
                  scope="col"
                  className="cart-table__header cart-table__header--name"
                >
                  {this.localizedKeys.productLabel}
                </th>
                {!this.isOrgDesktopColumnHidden && (
                  <th
                    scope="col"
                    className="cart-table__header cart-table__header--organization"
                  >
                    {
                      // only show ArcGis Online Organization if there is a subscription selector for a line.
                      this.state.token
                      && this.cart.metadata.validateCart.showSubscriptionHeader
                        ? this.localizedKeys.orgLabel
                        : ''
                    }
                  </th>
                )}
                {this.showAutoRenewableInfo && (
                  <th
                    scope="col"
                    className="cart-table__header cart-table__header--autorenew"
                  >
                    {this.showAutoRenewableInfo
                      ? this.localizedKeys.autoRenewLabel
                      : ''}
                  </th>
                )}
                <th
                  scope="col"
                  className="cart-table__header cart-table__header--price"
                >
                  {this.localizedKeys.priceLabel}
                </th>
                <th
                  scope="col"
                  className="cart-table__header cart-table__header--quantity"
                >
                  {this.localizedKeys.quantityLabel}
                </th>
                <th
                  scope="col"
                  className="cart-table__header cart-table__header--amount"
                >
                  {this.localizedKeys.lineItemTotalLabel}
                </th>
              </tr>
            </thead>
            <tbody>{this.products}</tbody>
            <tfoot>
              <tr className="cart-table__row">
                <td colSpan={100} className="cart-table__item--full-width">
                  <div className={`cartTotal padding-leader-2`}>
                    {
                      /* ERROR AREA FOR THE FOOTER START */
                      this.proceedToCheckoutError
                      && this.cart.metadata.validateCart
                        .subscriptionSelectionRequired
                        && !this.cart.metadata.isNotPurchasableProducts && (
                        <SubscriptionSelectionRequiredMessage
                          content={
                            this.localizedKeys
                              .subscriptionSelectionRequiredMessage
                          }
                        />
                      )
                    }

                    {/* ERROR AREA FOR THE FOOTER END */}
                    {this.renderCheckoutButtons(false, 'tablet')}
                    <div
                      className={`contactUs ${
                        this.state.isShareCartHidden
                          ? 'contactUs--offset-block-end'
                          : ''
                      }`}
                    >
                      {this.cart.metadata.isProratedPricing && (
                        <div className="proRated-pricing">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            className="svg-icon icon-ui-blue"
                          >
                            <path d="M15.5 1.001A14.499 14.499 0 1 0 30 15.5 14.5 14.5 0 0 0 15.5 1.001zM14 8.75a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75h-1.5a.75.75 0 0 1-.75-.75zM19 23h-6v-1h1l1-1v-6l-1-1v-1h3v8l1 1h1z" />
                          </svg>
                          <div className="richtext-container">
                            {this.localizedKeys
                              .cartProratedPricingDescription
                              && parse(
                                this.localizedKeys
                                  .cartProratedPricingDescription,
                              )}
                          </div>
                        </div>
                      )}
                      {this.localizedKeys.cartMoneyBackGuaranteeMessage && (
                        <div className="money-back-guarantee">
                          <div className="richtext-container">
                            {this.localizedKeys.cartMoneyBackGuaranteeMessage
                            && parse(
                              this.localizedKeys.cartMoneyBackGuaranteeMessage,
                            )}
                          </div>
                        </div>
                      )}
                      <PaymentOptionAssets
                        paymentAssets={this.paymentOptionAssetsData}
                        purchaseOrderLabel={
                          this.localizedKeys.purchaseOrderLabel
                        }
                        authorizationToInvoiceLabel={
                          this.localizedKeys.authorizationToInvoiceLabel
                        }
                      />
                      <div className="cart-btn-wrapper">
                        {!this.state.isShareCartHidden && (
                          <>
                            <calcite-button
                              class="share-cart-btn"
                              appearance="outline"
                              icon-start="link"
                              round
                              scale="m"
                              width="auto"
                              disabled={
                                this.state.isShareCartDisabled || undefined
                              }
                              onClick={this.handleShareCartClick}
                            >
                              {this.localizedKeys.shareCartLabel}
                            </calcite-button>
                            <calcite-alert
                              ref={this.shareCartAlert}
                              id="share-cart-alert"
                              icon="check-circle-f"
                              theme="light"
                              color="blue"
                              kind="brand"
                              active={
                                this.state.isShareCartAlertActive || undefined
                              }
                              open={
                                this.state.isShareCartAlertActive || undefined
                              }
                              dir="ltr"
                              role="alertdialog"
                              scale="m"
                            >
                              <div slot="title">
                                {this.localizedKeys.shareCartAlertTitle}
                              </div>
                              <div slot="message">
                                {this.localizedKeys.shareCartAlertMessage}
                              </div>
                            </calcite-alert>
                          </>
                        )}
                        {this.distPrintCart.isPrintCart && (
                          <calcite-button
                            class="print-cart-btn"
                            appearance="outline"
                            icon-start="print"
                            round
                            scale="m"
                            width="auto"
                            onClick={this.handlePrintCartClick}
                          >
                            {this.localizedKeys.printCartLabel || 'Print Cart'}
                          </calcite-button>
                        )}
                      </div>
                    </div>
                    {this.renderCheckoutButtons(false, 'desktop', true)}
                    {this.renderCartContactUs(
                      this.localizedKeys.callExpertNotSureText,
                    )}
                    <div className="quoteDisclaimerMessage">
                      <div className="richtext-container">
                        {this.localizedKeys.quoteDisclaimerMessage
                        && parse(this.localizedKeys.quoteDisclaimerMessage)}
                      </div>
                    </div>
                    <div className="text-center continue-shopping">
                      <a
                        className="calcite-link"
                        href={this.urls.storeHomePageUrl}
                      >
                        {this.localizedKeys.continueShoppingLabel}
                      </a>
                    </div>
                  </div>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div className="footnote grid-container trailer-half text-center">
          <div className="footnote-content">
            <div className="richtext-container">
              {this.localizedKeys.cartPricingFootnote
              && parse(this.localizedKeys.cartPricingFootnote)}
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderCheckoutButtons(isTotalHidden, className, isCheckoutBtnFirst) {
    const checkoutButton = (
      <div className="checkout-btn">
        <calcite-button scale="m" onClick={this.proceedToCheckout}>
          <div className="button-slotted-content">
            <span className="button-slotted-content__text">
              <span>{this.localizedKeys.continueCheckoutLabel}</span>
            </span>
            <calcite-icon
              class="button-slotted-content__icon margin-left--4 flip-rtl"
              scale="s"
              icon="arrow-right"
            ></calcite-icon>
          </div>
        </calcite-button>
      </div>
    );

    return (
      <div
        className={`checkout-amount-wrapper ${className || ''}  ${
          (!this.state.isShareCartHidden || !this.distPrintCart?.isPrintCart)
            ? 'checkout-amount-wrapper--offset-block-end-4'
            : ''
        }`}
      >
        {!isTotalHidden && (
          <div className="checkout-amount-wrapper-text">
            <div className="checkout-total">
              <span className="checkout-total-header ui-text-2">
                {this.localizedKeys.amountLabel}
              </span>
              <span className="checkout-total-amount esri-font-demi">
                {!this.cart.metadata.isNotPurchasableProducts
                  ? this.formatStorePrice(
                      this.cartSubtotalPrice,
                      this.cart.metadata.formattedLocale,
                      this.cart.metadata.currency,
                    )
                  : '-'}
              </span>
            </div>
            {!this.isDiscountAppliedHidden && (
              <div className="discount-alert avenir-bold esri-font-medium font-size--2">
                <calcite-icon
                  icon="check-circle"
                  scale="s"
                  aria-hidden="true"
                ></calcite-icon>
                {this.localizedKeys.discountAppliedLabel}
              </div>
            )}
          </div>
        )}
        <div className="checkout-amount-wrapper-buttons">
          {isCheckoutBtnFirst ? checkoutButton : null}
          {isCheckoutBtnFirst ? null : checkoutButton}
        </div>
      </div>
    );
  }

  renderProducts() {
    const isValidState = (item) => {
      return this?.state?.token && item?.metadata?.errorCode !== 9;
    };

    /** Scenario A - The line item has only one subscription, in that case subscription-selection is not displayed E.g. Credits, Viewer, Editor but with only one subscription etc.   */
    const isScenarioA = function (item) {
      return (
        isValidState(item)
        && item?.metadata?.subscriptions?.available?.length === 1
        && item?.metadata?.subscriptions?.selected?.[0]?.title
      );
    };

    /**  Scenario B - The line item has more than one subscriptions, in that case subscription selector is displayed E.g. Credits, Viewer, Editor etc.   */
    const isScenarioB = function (item) {
      return (
        isValidState(item)
        && item?.metadata?.subscriptions?.available?.length > 1
        && item?.metadata?.subscriptions?.selectorType === 'subscriptionSelector'
      );
    };

    /** Scenario C - The line item has multiple core licenses. E.g. Term extension  */
    const isScenarioC = function (item) {
      return (
        isValidState(item)
        && item?.metadata?.subscriptions?.available?.length > 1
        && item?.metadata?.subscriptions?.selectorType === 'coreLicenseSelector'
      );
    };
    /** Scenario D - License selected date. */
    const isScenarioD = function (item) {
      return (
        isValidState(item)
        && item?.metadata?.subscriptions?.selectorType !== 'coreLicenseSelector'
        && item?.termLicense
      );
    };
    const hostingRegionPickerId = this.cart.lineItems.find(
      (item) =>
        this.localizedKeys.hostingRegionLabel
        && this.hostingRegions.length
        && this.isHostingRegionRequired(item)
        && !this.isDefaultRegionUS(item),
    )?._id;

    // set autoRenewable flag
    this.showAutoRenewableInfo = !this.isAutoRenewalHidden(this.cart);
    this.cartSubtotalPrice = 0;
    this.isOrgDesktopColumnHidden = !(
      this.cart.metadata.validateCart.showSubscriptionHeader
      || this.cart.lineItems.some(
        (item) =>
          isScenarioA(item)
          || isScenarioB(item)
          || isScenarioC(item)
          || isScenarioD(item),
      )
    );
    this.isDiscountAppliedHidden = !this.cart.lineItems.some(
      (item) => item.metadata?.pricing?.volumeDiscountPercentage != null,
    );
    this.products = this.cart.lineItems.map((item, index) => {
      const productIcon
        = this.state.storeDomain + item.metadata.productInfo.productIcon;
      const defaultIcon
        = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs='; // blank image
      const validationError = item.metadata.errorCode
        ? this.setErrorMessage(
            item.metadata.errorCode,
            item.metadata.maxQtyAllowed,
          )
        : {};
      const pricingPageUrl = item.metadata.productInfo.pricingPageUrl
        ? this.state.storeDomain + item.metadata.productInfo.pricingPageUrl
        : '';
      const hidePrice
        = item.metadata.errorCode === 9
          || (item.metadata.subscriptions?.selectorType === 'coreLicenseSelector'
            && item.metadata.subscriptions?.available?.length > 1);
      const productIconElem = (
        <img
          className="product-icon"
          alt=""
          src={productIcon}
          onError={(e) => (e.target.src = defaultIcon)}
        />
      );

      this.cartSubtotalPrice += item.price * item.quantity;
      item.metadata.pricing.volumeDiscountPercentage
        = item.metadata.pricing.volumeDiscountPercentage > 0
          ? item.metadata.pricing.volumeDiscountPercentage
          : null; // if for whatever reason the volume discount is less than 0, make it null.

      return (
        <React.Fragment key={item._id}>
          <tr className="cart-table__row cart-table__row--primary">
            <th scope="row" className="cart-table__item cart-table__item--name">
              {pricingPageUrl
                ? (
                    <a
                      className="productTitle"
                      href={pricingPageUrl}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {productIconElem}
                      {item.productName}
                    </a>
                  )
                : (
                    <span className="productTitle">
                      {productIconElem}
                      {item.productName}
                    </span>
                  )}
            </th>
            {!this.isOrgDesktopColumnHidden && (
              <td
                className="cart-table__item cart-table__item--organization cart-table__item--title"
                data-title={
                  (this.cart.metadata.validateCart.showSubscriptionHeader
                    && (isScenarioA(item)
                      || isScenarioB(item)
                      || isScenarioC(item)
                      || isScenarioD(item))
                    && this.localizedKeys.orgLabel)
                  || ''
                }
              >
                <div
                  className={`organization-container ${
                    (isScenarioB(item)
                      && isScenarioD(item)
                      && hostingRegionPickerId !== item._id
                      && 'organization-container--term-offset')
                    || ''
                  } ${
                    (isScenarioB(item)
                      && isScenarioD(item)
                      && hostingRegionPickerId === item._id
                      && 'organization-container--term-hosting-offset')
                    || ''
                  }`}
                >
                  {/* There are mulitple scenarios based on which the subscription Info column displays Item */}
                  {isScenarioA(item) && (
                    <div
                      className="font-size--1"
                      style={{
                        marginTop: '10px',
                      }}
                    >
                      <svg
                        id="icon-ui-svg"
                        className="svg-icon icon-ui-blue"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <g id="icon-ui-svg--base">
                          <path d="M10.926 15.051l.065.866c.002.018-.002.036-.001.054l5.367 2.592a3.644 3.644 0 0 1 .324-.732zM10.57 10.872l5.434-2.625a6.285 6.285 0 0 1 .01-.563l.026-.343-5.678 2.743a4.529 4.529 0 0 1 .208.788zM5.961 9.1H3.04a2.58 2.58 0 0 0-2.59 2.368l-.346 4.607a1.167 1.167 0 0 0 .32.889 1.528 1.528 0 0 0 .815.33v.433A1.184 1.184 0 0 0 2.43 18.9H6.57a1.184 1.184 0 0 0 1.192-1.173v-.434a1.53 1.53 0 0 0 .817-.33 1.167 1.167 0 0 0 .319-.888l-.346-4.605A2.581 2.581 0 0 0 5.96 9.1zm2.055 7.296a1.852 1.852 0 0 1-.655.139h-.4v1.192a.384.384 0 0 1-.392.373H2.43a.384.384 0 0 1-.392-.373v-1.192h-.4a2.102 2.102 0 0 1-.636-.122.366.366 0 0 1-.101-.279l.346-4.609A1.779 1.779 0 0 1 3.04 9.9H5.96a1.78 1.78 0 0 1 1.792 1.627l.346 4.607a.365.365 0 0 1-.083.262zM4.496 7.9a2.4 2.4 0 1 0-2.4-2.4 2.403 2.403 0 0 0 2.4 2.4zm0-4a1.6 1.6 0 1 1-1.6 1.6 1.602 1.602 0 0 1 1.6-1.6zm18.219 15.685a1.54 1.54 0 0 0-1.49-1.485h-1.454a1.539 1.539 0 0 0-1.49 1.48l-.172 2.25a2.503 2.503 0 0 0 .423 1.743 1.02 1.02 0 0 0 .764.327H21.7a1.04 1.04 0 0 0 .782-.333 2.452 2.452 0 0 0 .405-1.747zm-.82 3.438a.238.238 0 0 1-.195.077h-2.404a.22.22 0 0 1-.18-.073 1.833 1.833 0 0 1-.209-1.14l.173-2.252a.74.74 0 0 1 .69-.735h1.456a.743.743 0 0 1 .69.74l.174 2.256a1.717 1.717 0 0 1-.194 1.126zM20.5 14.1a1.4 1.4 0 1 0 1.4 1.4 1.401 1.401 0 0 0-1.4-1.4zm0 2a.6.6 0 1 1 .6-.6.6.6 0 0 1-.6.6zm-1.204-6.2H21.7a1.04 1.04 0 0 0 .782-.333 2.452 2.452 0 0 0 .405-1.747l-.172-2.235a1.54 1.54 0 0 0-1.49-1.485h-1.454a1.539 1.539 0 0 0-1.49 1.48l-.172 2.25a2.503 2.503 0 0 0 .423 1.743 1.02 1.02 0 0 0 .764.327zm-.389-2.013l.173-2.252a.74.74 0 0 1 .69-.735h1.456a.743.743 0 0 1 .69.74l.174 2.256a1.717 1.717 0 0 1-.194 1.127.238.238 0 0 1-.196.077h-2.404a.22.22 0 0 1-.18-.073 1.833 1.833 0 0 1-.209-1.14zM20.5 2.9a1.4 1.4 0 1 0-1.4-1.4 1.401 1.401 0 0 0 1.4 1.4zm0-2a.6.6 0 1 1-.6.6.6.6 0 0 1 .6-.6z" />
                        </g>
                      </svg>
                      {item.metadata.subscriptions.selected[0].selectType === 'renewal'
                        ? (
                            <span>&nbsp;{this.localizedKeys.renewOrgLabel}</span>
                          )
                        : null}
                      &nbsp;
                      {item.metadata.subscriptions.selected[0].title}
                    </div>
                  )}
                  {isScenarioB(item) && (
                    <SubscriptionSelection
                      onChangeSelectedSubscriptions={(
                        newSelectedSubscriptions,
                      ) => {
                        this.onChangeSelectedSubscriptions(
                          newSelectedSubscriptions,
                          item,
                        );
                      }}
                      subscriptions={item.metadata.subscriptions.available}
                      selectedSubscriptions={
                        item.metadata.subscriptions.selected
                      }
                      lineItem={item}
                      localizedKeys={this.localizedKeys}
                      subscriptionSelectionRequired={
                        this.cart.metadata && this.cart.metadata.validateCart
                          ? this.cart.metadata.validateCart
                            .subscriptionSelectionRequired
                          : false
                      }
                      proceedToCheckoutError={this.proceedToCheckoutError}
                    />
                  )}
                  {isScenarioC(item) && (
                    <>
                      <calcite-link
                        class="font-size--2"
                        onClick={() =>
                          this.assignCoreLicenses(
                            item.metadata.subscriptions.available,
                            item,
                          )
                        }
                      >
                        <span className="link-slotted-content">
                          <calcite-icon
                            class="link-slotted-content__icon margin-right--1"
                            scale="s"
                            icon="plus-circle"
                          ></calcite-icon>
                          <span className="link-slotted-content__text">
                            {item.metadata.subscriptions.selected.length > 0
                              ? this.localizedKeys.editCoreLicensesLabel
                              : this.localizedKeys.assignCoreLicensesLabel}
                          </span>
                        </span>
                      </calcite-link>
                    </>
                  )}
                  {isScenarioD(item) && (
                    <span className="font-size--2 termLicense ui-text-2">
                      {this.localizedKeys.expireLabel}
                      {': '}
                      {this.formatStoreDate(
                        item.endDate,
                        this.cart.metadata.formattedLocale,
                      )}
                    </span>
                  )}
                  {hostingRegionPickerId === item._id && (
                    <HostingRegionPicker
                      activeHostingRegion={this.activeHostingRegion}
                      hostingRegions={this.hostingRegions}
                      continueLabel={this.localizedKeys.continueLabel}
                      hostingRegionLabel={this.localizedKeys.hostingRegionLabel}
                      hostingRegionInfoContent={
                        this.localizedKeys.hostingRegionInfoContent
                      }
                      hostingRegionSelectHeading={
                        this.localizedKeys.hostingRegionSelectHeading
                      }
                      hostingRegionSelectWarningMessage={
                        this.localizedKeys.hostingRegionSelectWarningMessage
                      }
                      onHostingRegionChange={this.handleHostingRegionChange}
                      disabled={this.hostingRegions.length <= 1}
                    />
                  )}
                </div>
              </td>
            )}
            {this.showAutoRenewableInfo && (
              <td
                className="cart-table__item cart-table__item--autorenew cart-table__item--title"
                data-title={
                  (this.showAutoRenewableInfo
                    && item.metadata.productInfo.autoRenewal
                    && this.localizedKeys.autoRenewLabel)
                  || ''
                }
              >
                <div>
                  {this.showAutoRenewableInfo
                  && item.metadata.productInfo.autoRenewal && (
                    <calcite-switch
                      name="autorenewal"
                      label={this.localizedKeys.autoRenewLabel || ''}
                      ref={(el) => (this.autoRenewalSwitchesEl[index] = el)}
                      value={item.metadata.isAuto}
                      checked={item.metadata.isAuto ? true : undefined}
                      switched={item.metadata.isAuto ? true : undefined}
                      scale="m"
                    ></calcite-switch>
                  )}
                </div>
              </td>
            )}
            <td className="cart-table__item cart-table__item--price">
              <div className="font-size-2">
                <div
                  data-product-price={item.price}
                  className={`price-value ui-text-2 ${
                    item.metadata.pricing.volumeDiscountPercentage
                      ? 'price-value--discount'
                      : ''
                  }`}
                >
                  {hidePrice
                    ? '-'
                    : this.formatStorePrice(
                        item.price,
                        this.cart.metadata.formattedLocale,
                        this.cart.metadata.currency,
                      )}
                </div>
                {item.metadata.pricing.volumeDiscountPercentage && (
                  <div className="discount-price-value ui-text-2">
                    {this.formatStorePrice(
                      item.metadata.pricing.quantityOnePrice,
                      this.cart.metadata.formattedLocale,
                      this.cart.metadata.currency,
                    )}
                  </div>
                )}
              </div>
            </td>
            <td
              className="cart-table__item cart-table__item--quantity cart-table__item--title"
              data-title={this.localizedKeys.quantityLabel || ''}
            >
              <div className="qtyLoader">
                <button
                  className="prc__less-qty-btn"
                  aria-label={Granite.I18n.get('Decrease quantity')}
                  onClick={() =>
                    this.onQuantityChange(item, item.quantity - 1, index)
                  }
                  disabled={this.state.onQuantityChange}
                >
                  <span className="prc__minus" data-click="handleQtyMinus">
                    −
                  </span>
                </button>
                <input
                  data-product-qty={item.quantity}
                  id={`cartQty${index}`}
                  value={item.quantity}
                  className={`prc__qty font-size-0 ${
                    item.metadata.pricing.volumeDiscountPercentage
                      ? 'prc__qty--discount'
                      : ''
                  }`}
                  onChange={(event) =>
                    this.onQuantityChange(item, event.target.value, index)
                  }
                  type="number"
                  disabled={this.state.onQuantityChange}
                  aria-label={Granite.I18n.get('Quantity')}
                />
                <button
                  className="prc__plus-qty-btn"
                  aria-label={Granite.I18n.get('Increase quantity')}
                  onClick={() =>
                    this.onQuantityChange(item, item.quantity + 1, index)
                  }
                  disabled={this.state.onQuantityChange}
                >
                  <span className="prc__plus" data-click="handleQtyPlus">
                    +
                  </span>
                </button>
              </div>
              <calcite-link
                class="font-size--2 removeButton"
                onClick={() => this.removeItem(item, 0, index)}
              >
                {this.localizedKeys.removeLabel}
                <span className="assistText">{item.productName}</span>
              </calcite-link>
            </td>
            <td
              className="cart-table__item cart-table__item--amount cart-table__item--title"
              data-title={this.localizedKeys.lineItemTotalLabel || ''}
            >
              <div className="font-size-2">
                <div
                  className={`price-value esri-font-medium ${
                    item.metadata.pricing.volumeDiscountPercentage
                      ? 'price-value--discount'
                      : ''
                  }`}
                >
                  {item.metadata.errorCode !== 9
                    ? this.formatStorePrice(
                        item.price * item.quantity,
                        this.cart.metadata.formattedLocale,
                        this.cart.metadata.currency,
                      )
                    : '-'}
                </div>
                {this.vatMessage && (
                  <p className="vat-label font-size--2">{this.vatMessage}</p>
                )}
              </div>
            </td>
          </tr>
          <tr className="cart-table__row cart-table__row--secondary">
            <td
              className="cart-table__item cart-table__item--full-width"
              colSpan={100}
            >
              <calcite-alert
                id={'arAlert' + index}
                theme="light"
                icon=""
                color="green"
                kind="success"
                auto-dismiss="true"
                auto-dismiss-duration="medium"
                auto-close="true"
                auto-close-duration="medium"
                active={this.autoRenewalAlerts[index]}
                open={this.autoRenewalAlerts[index]}
                aria-hidden="true"
                dir="ltr"
                role="alertdialog"
                scale="m"
              >
                <div slot="title">
                  {this.localizedKeys.autoRenewalAlertTitle}
                </div>
                <div slot="message">
                  {this.localizedKeys.autoRenewalAlertMessage}
                </div>
              </calcite-alert>
              {
                /* List core Licenses if any */
                this.state.token
                && item.metadata.subscriptions.selected.length > 0
                && item.metadata.subscriptions.available.length > 1
                && item.metadata.subscriptions.selectorType
                === 'coreLicenseSelector' && (
                  <div className="coreLicenseCartSection">
                    <CoreLicenseDropdown
                      assignedCoreLicenses={
                        item.metadata.subscriptions.selected
                      }
                      localizedKeys={this.localizedKeys}
                      formatStoreDate={this.formatStoreDate}
                      formatStorePrice={this.formatStorePrice}
                      locale={this.cart.metadata.formattedLocale}
                      currency={this.cart.metadata.currency}
                    />
                  </div>
                )
              }
              <div className="mobileRemove padding-leader-half text-right">
                <calcite-link
                  class="font-size--2 removeButton landscapeUp"
                  onClick={() => this.removeItem(item, 0, index)}
                >
                  {this.localizedKeys.removeLabel}
                </calcite-link>
              </div>
              {validationError && validationError.message && (
                <ValidationError
                  title={validationError.title}
                  message={validationError.message}
                  errorCode={validationError.errorCode}
                />
              )}
              {
                /* List core Licenses if any */
                this.state.token
                && item.metadata.subscriptions.selected.length > 0
                && item.metadata.subscriptions.available.length > 1
                && item.metadata.subscriptions.selectorType
                === 'coreLicenseSelector' && (
                  <div className="coreLicenseCartSection">
                    {this.renderAssignedCoreLicenses(
                      item.metadata.subscriptions.selected,
                    )}
                  </div>
                )
              }
            </td>
          </tr>
        </React.Fragment>
      );
    });

    this.setState({
      isLoaded: true,
      updateCart: false,
      proceedToCheckout: false,
    });
  }

  renderAssignedCoreLicenses(assignedCoreLicenses) {
    const listCoreLiscense = assignedCoreLicenses.map((license, index) => {
      return (
        <div key={index} className="config-item listitems incart leader-half">
          <div className="config-item-name">
            <div className="trailer-0 phone-trailer-half">
              {license.productName}
            </div>
            <div className="trailer-0 font-size--1">
              {license.subscriptionId && (
                <div className="inlineElement subid">
                  <span className="esri-font-demi">
                    {' '}
                    {this.localizedKeys.subscriptionIdLabel}{' '}
                  </span>
                  {license.subscriptionId}
                </div>
              )}
              <div className="inlineElement">
                <span className="esri-font-demi">
                  {' '}
                  {this.localizedKeys.expireLabel}{' '}
                </span>{' '}
                {this.formatStoreDate(
                  license.dates[0].endDate,
                  this.cart.metadata.formattedLocale,
                )}
              </div>{' '}
            </div>
          </div>
          <div
            className="config-item-assigned"
            data-pseudo-content={`${this.localizedKeys.licensesAssignedLabel}`}
          >
            {license.assignedQty}
          </div>
          <div
            className="config-item-subtotal incart"
            data-pseudo-content={`${this.localizedKeys.subTotalLabel}`}
          >
            {this.formatStorePrice(
              license.dates[0].price * license.assignedQty,
              this.cart.metadata.formattedLocale,
              this.cart.metadata.currency,
            )}
          </div>
        </div>
      );
    });

    return (
      <div className="configModal leader-1 coreLicenseList">
        <div className="configModal-content incart">
          <div className="config-item header trailer-half">
            <div className="config-item-name incart">
              {' '}
              {this.localizedKeys.coreLicensesAssignmentLabel}{' '}
            </div>
            <div className="config-item-assigned">
              {' '}
              {this.localizedKeys.licensesAssignedLabel}{' '}
            </div>
            <div className="config-item-subtotal incart">
              {' '}
              {this.localizedKeys.subTotalLabel}{' '}
            </div>
          </div>
          {listCoreLiscense}
        </div>
      </div>
    );
  }

  renderCartContactUs(callExpertStartText) {
    return (
      <div className="cart-contactus text-center">
        <span> {callExpertStartText} </span>
        <a
          className="cart-contactus__number calcite-link"
          href={this.urls.contactUsPageUrl}
          target="_blank"
          rel="noreferrer"
        >
          {this.localizedKeys.callExpertTalkText}{' '}
          <svg
            className="contact-call-icon"
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            width="24"
            viewBox="0 0 48 48"
          >
            <g>
              <path d="M28.94 10.577a7.34 7.34 0 0 1-1.753 5.372l-.608-.52a6.597 6.597 0 0 0-.711-9.288l.52-.608a7.338 7.338 0 0 1 2.553 5.044zm4.992-.578a12.826 12.826 0 0 0-4.468-8.815l-.52.607A12.111 12.111 0 0 1 30.25 18.87l.608.52A12.825 12.825 0 0 0 33.932 10zM36.396 33.637c-2.382-1.105-4.37-2.267-4.412-2.29a3.22 3.22 0 0 0-3.268.497 11.16 11.16 0 0 0-1.22 1.082c-1.053 1.031-1.642 1.54-2.501.919a29.094 29.094 0 0 1-5.51-5.437l-.04-.051a26.302 26.302 0 0 1-3.598-6.477c-.384-1 .327-1.49 1.617-2.27a11.795 11.795 0 0 0 1.343-.9 2.83 2.83 0 0 0 1.075-3.085 95.458 95.458 0 0 1-.983-4.817c-.51-2.89-1.396-3.931-3.949-4.642-2.659-.744-5.304 1.46-5.41 1.55-.059.048-5.817 4.877-2.12 13.911 2.612 6.383 4.571 9.154 6.277 11.168 1.53 2.194 3.705 4.799 9.205 8.962a13.873 13.873 0 0 0 8.461 3.113 10.895 10.895 0 0 0 5.716-1.536c.12-.083 2.926-2.075 2.893-4.835-.034-2.774-1.082-3.705-3.576-4.862zm.226 9.04c-.238.165-5.936 3.968-13.237-1.557-5.411-4.097-7.539-6.642-9.054-8.812-1.686-1.994-3.601-4.704-6.17-10.983-3.465-8.468 1.665-12.808 1.89-12.993a6.834 6.834 0 0 1 3.766-1.518 3.418 3.418 0 0 1 .918.122c2.255.629 2.918 1.416 3.376 4.011.462 2.618.987 4.84 1.006 4.908a2.064 2.064 0 0 1-.815 2.234 11.065 11.065 0 0 1-1.253.836c-1.215.736-2.591 1.57-1.95 3.242a27.405 27.405 0 0 0 3.732 6.703 29.808 29.808 0 0 0 5.695 5.623c1.447 1.047 2.553-.04 3.53-.996a10.58 10.58 0 0 1 1.13-1.006 2.457 2.457 0 0 1 2.416-.442c.02.011 2.039 1.192 4.457 2.314 2.386 1.107 3.084 1.785 3.113 4.146.028 2.333-2.526 4.152-2.55 4.168z" />
            </g>
          </svg>
        </a>
      </div>
    );
  }

  assignCoreLicenses(coreLicenses, coreLicensesLineItem) {
    // Update current selected quantity if already assigned and/or update available qty if cart core associated line item quantity changed in case.
    _.forEach(coreLicenses, (license) => {
      // Check if there are any existing selected core for this line Item (extension).
      const existingSelectedCoreLicense
        = coreLicensesLineItem.metadata.subscriptions.selected.length > 0
          ? _.find(
              coreLicensesLineItem.metadata.subscriptions.selected,
              (selectedLicense) => selectedLicense.itemId === license.itemId,
            )
          : {};

      license.assignedQty = !_.isEmpty(existingSelectedCoreLicense)
        ? existingSelectedCoreLicense.assignedQty
        : 0;

      if (license.selectType === 'new') {
        const associatedCartCoreItem = _.find(this.cart.lineItems, {
          _id: license.associatedLineItemId,
        });

        if (associatedCartCoreItem) {
          if (
            associatedCartCoreItem.metadata.subscriptions.selected.length > 0
          ) {
            const itemIdParams = {
              subscriptionId:
                associatedCartCoreItem.metadata.subscriptions.selected[0]
                  .subscriptionId,
              sku: associatedCartCoreItem.materialNumber.toString(),
              endDate:
                associatedCartCoreItem.metadata.subscriptions.selected[0]
                  .dates[0].endDate,
              selectType: 'new',
            };
            license.itemId = this.generateSubscriptionItemId(itemIdParams);
          }

          license.subscriptionId = associatedCartCoreItem.subscriptionId;
          license.availableQty = associatedCartCoreItem.quantity;
          license.assignedQty
            = license.assignedQty > license.availableQty
              ? license.availableQty
              : license.assignedQty;
          license.deleted = false;
        } else {
          license.deleted = true; // This item is no longer (may be removed) in the cart.
        }
      }
    });

    this.setState({
      coreLicenses: coreLicenses,
      coreLicensesLineItem: coreLicensesLineItem,
    });
    this.showHideModal(
      '#coreLicenseSelectionModal',
      '#coreLicenseSelectionModalContent',
      'show',
    );
  }

  onAssignCoreLicenses(updatedLineItem) {
    if (updatedLineItem) {
      updatedLineItem.metadata.errorCode = 0;
      this.checkIfCartValid();
      this.updateCartItem(updatedLineItem, updatedLineItem.quantity);
      DataService.updateCart(this.urls.istApiUrl, this.cart);
    }

    this.setState({coreLicenses: null, coreLicensesLineItem: null});
    this.showHideModal(
      '#coreLicenseSelectionModal',
      '#coreLicenseSelectionModalContent',
      'hide',
    );
    this.renderShoppingCart();
    this.renderProducts();
  }

  handleShareCartClick() {
    const appendReferralParams = (url) => {
      const epnId = this.getCookie('epn_id');
      const sfId = this.getCookie('sf_id');
      if (epnId) {
        url += `&epn_id=${epnId}`;
      } else if (sfId) {
        url += `&sf_id=${sfId}`;
      }
      return url;
    };

    const onSuccess = (shareCart) => {
      this.shareCart = shareCart;
      const shareId = shareCart._id;
      let shareUrl = `${window.storeVariables.cartUrl}?share-id=${shareId}`;
      shareUrl = appendReferralParams(shareUrl);
      navigator.clipboard.writeText(shareUrl);
      this.setState({
        isShareCartAlertActive: true,
        isShareCartDisabled: false,
      });
    };

    const onError = (err) => {
      console.error('Error: ', err);
      this.analytics.addEvent(Analytics.eventType.ERROR, {
        errorDesc: `${err?.name}: ${err?.message}`,
      });
      this.setState({
        isShareCartDisabled: false,
      });
    };

    const isEqual = (a1, a2) => {
      return JSON.stringify(a1) === JSON.stringify(a2);
    };

    if (this.state.isShareCartDisabled) return;

    this.setState({
      ...(this.state.isShareCartAlertActive && {
        isShareCartAlertActive: false,
      }),
      isShareCartDisabled: true,
    });

    if (isEqual(this.shareCart?.lineItems, this.cart?.lineItems)) {
      onSuccess(this.shareCart);
      return;
    }

    this.getBuildAndShareCart().then(onSuccess).catch(onError);
  }

  getBuildAndShareCart() {
    const tempCart = {
      ...this.cart,
      cartType: cartType.BUILDANDSHARE,
    };
    delete tempCart._id;
    return DataService.createCart(this.urls.istApiUrl, tempCart);
  }

  handleShareCartAlertClose(event) {
    if (!this.state.isShareCartAlertActive) return;

    this.setState({isShareCartAlertActive: false});
  }

  // Action (To-do) functions
  async proceedToCheckout() {
    if (this.state.proceedToCheckout) return;

    try {
      this.setState({proceedToCheckout: true});
      this.setAdobeDataLayer('Omni Checkout');
      const items = Analytics.toItems(
        [this.origCart, this.cart],
        Analytics.dataType.CART_DELTA,
      );

      if (!this.state.token) {
        if (items.length)
          this.analytics.addEvent(Analytics.eventType.CART_ADD, {
            items,
            ...(this.cart && {cartID: this.cart._id}),
          });
        const loginRedirectUri = this.addQueryString(
          window.location.href,
          'signin=true',
        );
        window.redirectToSignIn(loginRedirectUri);
        // window.location.href = this.urls.accountsUrl + "/?redirect_uri=" + encodeURIComponent(loginRedirectUri);
      } else {
        if (
          !this.cart.metadata.validateCart.isCartValid
          || this.cart.metadata.validateCart.subscriptionSelectionRequired
        ) {
          this.setState({proceedToCheckout: false});
          this.proceedToCheckoutError = true;
          this.renderProducts();
          this.showHideModal(
            '#cartValidationErrorModal',
            '#cartValidationErrorMessage',
            'show',
          );
          this.analytics.addEvent(Analytics.eventType.ERROR, {
            errorDesc: 'Cart Items Missing Information',
          });
          const errorMessage = this.analytics.getPageItem('errorMessage') || [];
          errorMessage.push({
            event: 'eventWebAppMsg',
            data: {
              eventType: 'page error',
              errorMessage: 'Cart Items Missing Information',
            },
          });
          this.analytics.addPageInfo({
            errorMessage: errorMessage,
          });
          // this.toggleCartErrorModal('open');
        } else {
          const requestBody = {
            cartId: this.state.cartId,
            userLocale: this.state.userLocale,
            storeDomain: this.state.storeDomain,
          };

          const shoppingCartResponse = await DataService.processShoppingCart(
            this.urls.istApiUrl,
            requestBody,
          );
          this.cart = shoppingCartResponse.cart;
          this.setSelectSubscriptionRequired();

          if (
            this.cart.metadata.validateCart.isCartValid
            && !this.cart.metadata.validateCart.subscriptionSelectionRequired
          ) {
            if (
              !this.cart.metadata.customer
              || !this.cart.metadata.customer.customerNumber
            ) {
              this.goToCustomerNumberPage();
            } else {
              if (items.length)
                this.analytics.addEvent(Analytics.eventType.CART_ADD, {
                  items,
                  ...(this.cart && {cartID: this.cart._id}),
                });
              this.analytics.addEvent(Analytics.eventType.CHECKOUT_START, {
                checkoutFlow: {
                  action: 'checkout',
                  step: 1,
                },
                ...(this.cart && {cartID: this.cart._id}),
                items: Analytics.toItems([this.cart], Analytics.dataType.CART),
              });
              window.location.href = this.urls.checkoutUrl;
            }
          } else {
            this.setState({proceedToCheckout: false});
            this.proceedToCheckoutError = true;
            this.renderProducts();
          }
        }
      }
    } catch (e) {
      this.analytics.addEvent(Analytics.eventType.ERROR, {
        errorDesc: `${e?.name}: ${e?.message}`,
      });
      this.setState({isLoaded: true, proceedToCheckoutError: true});
    }
  }

  async onQuantityChange(lineItem, newQty, itemIndex) {
    this.setState({onQuantityChange: true});

    newQty = parseInt(newQty);
    newQty = !newQty || newQty === 0 ? 1 : newQty; // if 0 or no qty, set the min to 1.
    newQty = newQty > 999 ? 999 : newQty;

    // remove errorCode for all item on quantity change and let it recalculate again.
    _.forEach(this.cart.lineItems, (item) => {
      if (item.metadata.errorCode !== 9) {
        item.metadata.errorCode = 0;
      }
    });

    this.updateGlobalNavCartQuantity(lineItem.quantity, newQty);

    if (newQty > 0) {
      lineItem.quantity = newQty;
      this.checkMaxQtyAllowRules(lineItem, newQty);
      this.checkIfCartValid();
      this.updateCartItem(lineItem, newQty);
      this.updateCartMetadata();
      this.updateCartPurchaseEligible();

      DataService.updateCart(this.urls.istApiUrl, this.cart);
    } else if (newQty === 0) {
      this.removeItem(lineItem, newQty, itemIndex); // Remove item.
    }

    const total = this.formatStorePrice(
      lineItem.price,
      this.cart.metadata.formattedLocale,
      this.cart.metadata.currency,
    );
    announce(
      Granite.I18n.get('ProductQuantityChange', [
        lineItem.productName,
        total,
        lineItem.quantity,
      ]),
    );
    this.renderProducts();
    this.renderShoppingCart();

    this.setState({onQuantityChange: false});
  }

  validateCoreLicensesQtyMatch(lineItem) {
    if (lineItem.metadata.totalAvailableQty < lineItem.quantity) {
      lineItem.metadata.errorCode = 4;
      this.cart.metadata.isCartValid = false;
    } else {
      const totalAssignedCoreLicenses
        = lineItem.metadata.assignedCoreLicenses
          && lineItem.metadata.assignedCoreLicenses.length > 0
          ? _.sumBy(lineItem.metadata.assignedCoreLicenses, ['assignedQty'])
          : 0;
      if (totalAssignedCoreLicenses < lineItem.quantity) {
        lineItem.metadata.errorCode = 3;
        this.cart.metadata.isCartValid = false;
      }
    }
  }

  async onChangeSelectedSubscriptions(newSelectedSubscriptions, lineItem) {
    if (newSelectedSubscriptions[0].selectType === 'new') {
      for (const item of this.cart.lineItems) {
        const newSubscriptions = item.metadata.subscriptions.available.filter(
          (subscription) => subscription.selectType === 'new',
        );

        if (newSubscriptions.length !== 1) {
          continue;
        }

        this.setSelectedSubscription(item, newSubscriptions);
        await this.updateAssociatedLineItemPrice(item);
        this.checkPremiumAppEligibility(item);
        this.updateCartItem(item, item.quantity);
      }
    } else {
      this.setSelectedSubscription(lineItem, newSelectedSubscriptions);
      await this.updateAssociatedLineItemPrice(lineItem);
      this.checkPremiumAppEligibility(lineItem);
      this.updateCartItem(lineItem, lineItem.quantity);
    }

    this.updateCartPurchaseEligible();
    this.updateItemsHostingRegion();
    this.setSelectSubscriptionRequired();
    this.updateCartMetadata();
    DataService.updateCart(this.urls.istApiUrl, this.cart);

    this.renderProducts();
  }

  setSelectedSubscription(item, subscriptions) {
    const primarySubscription = subscriptions[0];
    let assignedQtyOverrideValue;
    if (subscriptions.length > 1) {
      assignedQtyOverrideValue = 0;
    } else if (subscriptions.length === 1 && item.quantity > primarySubscription.availableQty) {
      assignedQtyOverrideValue = primarySubscription.availableQty;
    } else if (subscriptions.length === 1 && item.quantity <= primarySubscription.availableQty) {
      assignedQtyOverrideValue = item.quantity;
    }

    primarySubscription.assignedQty = primarySubscription.assignedQty || assignedQtyOverrideValue;
    item.metadata.subscriptions.selected = subscriptions;

    // Update line item data.
    item.subscriptionId = primarySubscription.subscriptionId;
    item.metadata.subscriptionType = primarySubscription.selectType;
    item.metadata.orgName = primarySubscription.SubscriptionOrgURL;

    // Set dates and the price for the line item.
    if (primarySubscription.dates.length > 0) {
      item.endDate
        = primarySubscription.dates[0].endDate + 'T00:00:00.000Z';
      item.startDate
        = primarySubscription.dates[0].startDate + 'T00:00:00.000Z';
      item.price = primarySubscription.dates[0].price;

      item.metadata.pricing = {
        itemTotalPrice: item.price * item.quantity,
        listPrice: primarySubscription.dates[0].listPrice,
        vatListPrice: primarySubscription.dates[0].vatListPrice,
        pricingTiers: primarySubscription.dates[0].pricingTiers,
        quantityOnePrice: primarySubscription.dates[0].quantityOnePrice,
      };
    }
  }

  async updateAssociatedLineItemPrice(subscriptionUpdateLineItem) {
    const pricingLineItemRequest = [];

    _.forEach(this.cart.lineItems, (lineItem) => {
      if (subscriptionUpdateLineItem._id !== lineItem._id) {
        // If there is an available subscription for this line item, update data
        const availableSubscriptionAssociatedItem = _.find(
          lineItem.metadata.subscriptions.available,
          {
            associatedLineItemId: subscriptionUpdateLineItem._id,
          },
        );

        if (availableSubscriptionAssociatedItem) {
          availableSubscriptionAssociatedItem.subscriptionId
            = subscriptionUpdateLineItem.subscriptionId;
          const itemIdParams = {
            subscriptionId: availableSubscriptionAssociatedItem.subscriptionId,
            sku: availableSubscriptionAssociatedItem.sku,
            endDate: availableSubscriptionAssociatedItem.dates[0].endDate,
            selectType: availableSubscriptionAssociatedItem.selectType,
          };
          availableSubscriptionAssociatedItem.itemId
            = this.generateSubscriptionItemId(itemIdParams);

          // If there is an available subscription for this line item, update subscription id.
          const selectedSubscriptionAssociatedItem = _.find(
            lineItem.metadata.subscriptions.selected,
            {
              associatedLineItemId: subscriptionUpdateLineItem._id,
            },
          );
          if (selectedSubscriptionAssociatedItem) {
            selectedSubscriptionAssociatedItem.subscriptionId
              = subscriptionUpdateLineItem.subscriptionId;
            const itemIdParams = {
              subscriptionId: selectedSubscriptionAssociatedItem.subscriptionId,
              sku: selectedSubscriptionAssociatedItem.sku,
              endDate: selectedSubscriptionAssociatedItem.dates[0].endDate,
              selectType: selectedSubscriptionAssociatedItem.selectType,
            };
            selectedSubscriptionAssociatedItem.itemId
              = this.generateSubscriptionItemId(itemIdParams);
          }

          if (
            availableSubscriptionAssociatedItem.dates[0].endDate
            + 'T00:00:00.000Z'
            !== subscriptionUpdateLineItem.endDate
          ) {
            pricingLineItemRequest.push({
              lineItemId: lineItem._id,
              itemId: availableSubscriptionAssociatedItem.itemId,
              productIdentifierType: 'productId',
              productIdentifierValue: lineItem.materialNumber.toString(),
              quantity: lineItem.quantity,
              startDate: subscriptionUpdateLineItem.startDate,
              endDate: subscriptionUpdateLineItem.endDate,
            });
          }
        }
      }
    });

    if (pricingLineItemRequest.length > 0) {
      const pricingResponse = await DataService.getPrice(
        this.urls.istApiUrl,
        pricingLineItemRequest,
        this.cart.zone,
        this.cart.currency,
        this.cart.distributorNumber,
      );

      if (pricingResponse && pricingResponse.length > 0) {
        // Sync request itemId to response itemId
        // NOTE: Sometimes response is cached and can return previous request itemId.
        for (let i = 0; i < pricingLineItemRequest.length; i++) {
          pricingResponse[i].itemId = pricingLineItemRequest[i].itemId;
        }

        _.forEach(pricingResponse, (pricing) => {
          const cartLineItem = _.find(this.cart.lineItems, {
            _id: pricing.lineItemId,
          });

          if (cartLineItem) {
            const availableSubscriptionAssociatedItem = _.find(
              cartLineItem.metadata.subscriptions.available,
              {itemId: pricing.itemId},
            );
            const selectedSubscriptionAssociatedItem = _.find(
              cartLineItem.metadata.subscriptions.selected,
              {itemId: pricing.itemId},
            );

            if (availableSubscriptionAssociatedItem) {
              availableSubscriptionAssociatedItem.subscriptionId
                = subscriptionUpdateLineItem.subscriptionId;
              availableSubscriptionAssociatedItem.dates[0].endDate = dayjs
                .utc(pricing.endDate)
                .format('YYYY-MM-DD');
              availableSubscriptionAssociatedItem.dates[0].price
                = pricing.price;
              availableSubscriptionAssociatedItem.dates[0].listPrice
                = pricing.listPrice;
              availableSubscriptionAssociatedItem.dates[0].vatListPrice
                = pricing.vatListPrice;
              availableSubscriptionAssociatedItem.dates[0].pricingTiers
                = pricing.pricingTiers;
              availableSubscriptionAssociatedItem.dates[0].quantityOnePrice
                = pricing.quantityOnePrice;

              const itemIdParams = {
                subscriptionId:
                  availableSubscriptionAssociatedItem.subscriptionId,
                sku: availableSubscriptionAssociatedItem.sku,
                endDate: availableSubscriptionAssociatedItem.dates[0].endDate,
                selectType: availableSubscriptionAssociatedItem.selectType,
              };
              availableSubscriptionAssociatedItem.itemId
                = this.generateSubscriptionItemId(itemIdParams);
            }

            if (selectedSubscriptionAssociatedItem) {
              selectedSubscriptionAssociatedItem.dates[0].endDate = dayjs
                .utc(pricing.endDate)
                .format('YYYY-MM-DD');
              selectedSubscriptionAssociatedItem.dates[0].price = pricing.price;
              selectedSubscriptionAssociatedItem.dates[0].listPrice
                = pricing.listPrice;
              selectedSubscriptionAssociatedItem.dates[0].vatListPrice
                = pricing.vatListPrice;
              selectedSubscriptionAssociatedItem.dates[0].pricingTiers
                = pricing.pricingTiers;
              selectedSubscriptionAssociatedItem.dates[0].quantityOnePrice
                = pricing.quantityOnePrice;

              const itemIdParams = {
                subscriptionId:
                  selectedSubscriptionAssociatedItem.subscriptionId,
                sku: selectedSubscriptionAssociatedItem.sku,
                endDate: selectedSubscriptionAssociatedItem.dates[0].endDate,
                selectType: selectedSubscriptionAssociatedItem.selectType,
              };
              selectedSubscriptionAssociatedItem.itemId
                = this.generateSubscriptionItemId(itemIdParams);

              let newLineItemTotal = 0;
              _.forEach(
                cartLineItem.metadata.subscriptions.selected,
                (selectedSub) => {
                  newLineItemTotal
                    += selectedSub.dates[0].price * selectedSub.assignedQty;
                },
              );

              cartLineItem.metadata.pricing.itemTotalPrice = newLineItemTotal;
              cartLineItem.price = this.roundToTwo(
                newLineItemTotal / cartLineItem.quantity,
              );
            }
          }
        });
      }
    }
  }

  generateSubscriptionItemId(params) {
    return `${params.subscriptionId}${params.sku}${dayjs(params.endDate).format(
      'YYYYMMDD',
    )}${params.selectType}`;
  }

  roundToTwo(num) {
    return +(Math.round(num + 'e+2') + 'e-2');
  }

  onAutoRenewalFlagChange(item, autoRenewalFlagValue, index) {
    // Reset auto renewal flag.
    this.cart.metadata.renewalType = 'manual';
    this.cart.metadata.isAuto = false;

    item.metadata.isAuto = autoRenewalFlagValue;

    _.forEach(this.cart.lineItems, (lineItem) => {
      if (lineItem.metadata.isAuto) {
        this.cart.metadata.isAuto = true;
        this.cart.metadata.renewalType = 'auto';
        lineItem.metadata.renewalType = 'auto';
        return false;
      }
    });

    if (autoRenewalFlagValue) {
      this.autoRenewalAlerts[index] = true;
    }

    this.renderProducts();

    DataService.updateCart(this.urls.istApiUrl, this.cart);
  }

  // Helper functions
  updateCartItem(lineItem, quantity) {
    const prices = getItemPrices(lineItem);
    lineItem.price = prices.price;
    if (lineItem.metadata?.pricing) {
      lineItem.metadata.pricing.quantityOnePrice = prices.quantityOnePrice;
    }
    lineItem.quantity = quantity;
    lineItem.metadata.pricing.itemTotalPrice
      = lineItem.metadata.errorCode !== 9
        ? lineItem.price * lineItem.quantity
        : null;

    // Since core license selector doesn't have volume discount and the pricing tier doesn't apply, ignore it.
    if (
      lineItem.metadata.subscriptions
      && lineItem.metadata.subscriptions.selectorType !== 'coreLicenseSelector'
    ) {
      this.setVolumeDiscountPrice(lineItem);
    }
  }

  async removeItem(lineItem, newQty, itemIndex) {
    const origLineItem = JSON.parse(JSON.stringify(lineItem));
    this.updateskuListCookie(lineItem.materialNumber);
    this.updateGlobalNavCartQuantity(lineItem.quantity, newQty);

    if (this.autoRenewalSwitchesEl && this.autoRenewalSwitchesEl[itemIndex]) {
      this.autoRenewalSwitchesEl[itemIndex].removeEventListener(
        'calciteSwitchChange',
        () => {},
      );
    }

    lineItem.quantity = newQty;
    this.renderProducts();

    setTimeout(
      function () {
        _.remove(this.cart.lineItems, {_id: lineItem._id});
        this.updateCartPurchaseEligible();
        this.updateCartMetadata();
        DataService.updateCart(this.urls.istApiUrl, this.cart);

        this.checkIfCartValid();
        this.setState({
          isCartEmpty: this.cart.lineItems.length === 0,
        });

        this.renderProducts();
        this.analytics.addEvent(Analytics.eventType.CART_REMOVE, {
          ...(this.cart && {cartID: this.cart._id}),
          items: Analytics.toItems(
            [{...this.cart, lineItems: [origLineItem]}],
            Analytics.dataType.CART,
          ),
        });
      }.bind(this),
      600,
    );
  }

  updateCartMetadata() {
    let isNotPurchasableProducts = false;
    let isProratedPricing = false;
    let isSingleAutoRenewalProduct = false;
    let subTotal = 0;

    _.forEach(this.cart.lineItems, (item) => {
      const activeListPrice = isVatActive() ? item.metadata.pricing.vatListPrice : item.metadata.pricing.listPrice;
      if (item.metadata.pricing.quantityOnePrice < activeListPrice) {
        isProratedPricing = true;
      }

      if (item.metadata.errorCode === 9) {
        isNotPurchasableProducts = true;
        item.price = 0; // since swagger doesn't allow null value for any attribute, i have to set the price to 0;
      }

      if (item.metadata.productInfo.autoRenewal) {
        isSingleAutoRenewalProduct = true;
      }

      subTotal += item.price * item.quantity;
    });

    this.cart.metadata.isProratedPricing = isProratedPricing;
    this.cart.metadata.isNotPurchasableProducts = isNotPurchasableProducts;
    this.cart.metadata.showAutoRenewalHeader = isSingleAutoRenewalProduct;
  }

  setGlobalNavCartQuantity(qty) {
    if (!window.esriShoppingCart?.setCartCount) {
      return console.error('setCartCount not defined');
    }
    if (isNaN(qty)) {
      return console.error('qty is not a number');
    }

    window.esriShoppingCart.setCartCount(qty);
  }

  updateGlobalNavCartQuantity(existingQty, newQty) {
    if (window.esriShoppingCart) {
      if (existingQty > newQty) {
        window.esriShoppingCart.removeItemsFromCart(existingQty - newQty);
      } else if (existingQty < newQty) {
        window.esriShoppingCart.addItemsToCart(newQty - existingQty);
      }
    }
  }

  checkMaxQtyAllowRules(lineItem, newQty) {
    if (newQty > lineItem.metadata.maxQtyAllowed) {
      lineItem.metadata.errorCode = 2;
    } else if (this.state.token) {
      this.checkPremiumAppEligibility(lineItem);
    }
  }

  updateCartPurchaseEligible() {
    if (!this.cart?.lineItems?.length) return;

    this.cart.lineItems.forEach((lineItem) => {
      const selectedSubscription
        = lineItem?.metadata?.subscriptions?.selected?.[0];
      if (!selectedSubscription?.usersEligibility?.[lineItem.materialNumber])
        return;

      const sameSubscriptionItems = this.cart.lineItems.filter((item) =>
        sameSubscription(item, lineItem),
      );
      const parents = lineItem?.metadata?.parents || [];
      const parentsInCart = intersectionBy(
        sameSubscriptionItems,
        parents,
        getSku,
      );
      const totalParentQty = sumBy(parentsInCart, 'quantity');

      selectedSubscription.usersEligibility[
        lineItem.materialNumber
      ].cartPurchaseEligible = totalParentQty || 0;
      this.checkPremiumAppEligibility(lineItem);
    });

    function sameSubscription(item1, item2) {
      if (!item1 || !item2) return false;
      if (item1._id === item2._id) return false;

      const item1Sub = item1?.metadata?.subscriptions?.selected?.[0];
      const item2Sub = item2?.metadata?.subscriptions?.selected?.[0];
      if (!item1Sub || !item2Sub) return false;

      return item1Sub.subscriptionId === item2Sub.subscriptionId;
    }

    function getSku(item) {
      return (item?.materialNumber || item?.sku)?.toString();
    }
  }

  isPurchaseEligible(lineItem) {
    const selectedSubscription
      = lineItem?.metadata?.subscriptions?.selected?.[0];
    const sku = lineItem?.materialNumber?.toString();
    const itemUsersEligibility = selectedSubscription?.usersEligibility?.[sku];
    if (!itemUsersEligibility) return true;

    const cartPurchaseEligible
      = itemUsersEligibility?.cartPurchaseEligible || 0;
    const purchaseEligible = itemUsersEligibility?.purchaseEligible || 0;
    return lineItem.quantity <= purchaseEligible + cartPurchaseEligible;
  }

  checkPremiumAppEligibility(lineItem) {
    const selectedSubscription = lineItem.metadata.subscriptions.selected[0];
    const sku = lineItem.materialNumber.toString();

    if (
      selectedSubscription
      && selectedSubscription.usersEligibility
      && Object.keys(selectedSubscription.usersEligibility).length > 0
      && selectedSubscription.usersEligibility[sku]
    ) {
      if (!this.isPurchaseEligible(lineItem)) {
        lineItem.metadata.errorCode = 3;
        this.cart.metadata.validateCart.isCartValid = false;
      } else {
        delete lineItem.metadata.errorCode;
        this.checkIfCartValid();
      }
    }
  }

  checkIfCartValid() {
    this.cart.metadata.validateCart = this.cart.metadata.validateCart || {};
    this.cart.metadata.validateCart.isCartValid = true;

    this.cart.lineItems.map((item) => {
      if (item.metadata.errorCode) {
        this.cart.metadata.validateCart.isCartValid = false;
        return false;
      }
    });
  }

  setAutoRenewalProducts(lineItem, renewalConfigs) {
    lineItem.metadata.productInfo = lineItem.metadata.productInfo || {};
    lineItem.metadata.productInfo.autoRenewal
      = renewalConfigs[lineItem._id].auto;

    if (lineItem.metadata.productInfo.autoRenewal) {
      lineItem.metadata.isAuto = lineItem.metadata.isAuto || false;
    }
  }

  setVolumeDiscountPrice(lineItem) {
    lineItem.metadata.pricing.volumeDiscountPercentage = null;
    if (
      lineItem.price
      && lineItem.metadata?.pricing?.quantityOnePrice
      && lineItem.metadata?.subscriptions?.selected?.length
    ) {
      const volumeDiscountPercentage
        = lineItem.metadata.errorCode !== 9
          ? parseInt(
              100
              - (lineItem.price / lineItem.metadata.pricing.quantityOnePrice)
              * 100,
            )
          : 0;
      lineItem.metadata.pricing.volumeDiscountPercentage
        = volumeDiscountPercentage <= 0 ? null : volumeDiscountPercentage;
    }
  }

  setSelectSubscriptionRequired() {
    this.cart.metadata.validateCart.subscriptionSelectionRequired = false;

    this.cart.lineItems.map((lineItem) => {
      if (
        lineItem.metadata.subscriptions.available.length >= 1
        && lineItem.metadata.subscriptions.selected.length === 0
        && lineItem.metadata.subscriptions.selectorType === 'subscriptionSelector'
      ) {
        this.cart.metadata.validateCart.subscriptionSelectionRequired = true;
      }
    });
  }

  setErrorMessage(errorCode, maxQtyAllowed) {
    const errorMessage = {};

    switch (errorCode) {
      case 2:
        errorMessage.title = this.localizedKeys.errorMessage2Title;
        errorMessage.message = this.localizedKeys.errorMessage2.replace(
          '{qty}',
          maxQtyAllowed,
        );
        errorMessage.errorCode = errorCode;
        break;
      default:
        errorMessage.title
          = this.localizedKeys['errorMessage' + errorCode + 'Title'];
        errorMessage.message = this.localizedKeys['errorMessage' + errorCode];
        errorMessage.errorCode = errorCode;
        break;
    }

    return errorMessage;
  }

  toggleCartErrorModal(modalAction) {
    const modal = document.querySelector('.cartErrorModal');
    if (modalAction === 'open') {
      modal.open();
    } else {
      modal.close();
    }
  }

  setAdobeDataLayer(eventType, data) {
    const lineItems = [];

    _.forEach(this.cart.lineItems, (item) => {
      const activeListPrice = isVatActive() ? item.metadata.pricing.vatListPrice : item.metadata.pricing.listPrice;
      lineItems.push({
        quantity: item.quantity,
        price: {
          basePrice: activeListPrice,
          salePrice: item.price,
        },
        productInfo: {
          productSku: item.materialNumber.toString(),
          productName: item.productName,
          productQty: item.quantity,
        },
      });
    });

    this.analytics.addPageInfo({
      subtotal: this.cart.metadata.numericSubtotal,
      purchaseCurrency: this.cart.currency,
      distributorNumber: this.cart.distributorNumber,
      countryCode: this.cart.metadata.shippingAddress
        ? this.cart.metadata.shippingAddress.countryCode
        : null,
      storeType: this.cart.zone.toLowerCase() + ' - store',
      storefront: 'Omni',
      items: lineItems,
    });

    if (window._satellite) {
      window._satellite.track(eventType); // "Omni Checkout"
    }
  }

  showHideModal(modalName, modalErrorMsg, type) {
    const modal = document.querySelector(modalName);
    const modalContent = document.querySelector(modalErrorMsg);

    if (modal) {
      if (type === 'show') {
        modal.dataset.attribute = 'visible';
      } else {
        modal.dataset.attribute = 'hidden';
      }
    }

    if (modalContent) {
      if (type === 'show') {
        modalContent.dataset.attribute = 'visible';
      } else {
        modalContent.dataset.attribute = 'hidden';
      }
    }
  }

  setLocalizedContent() {
    const localizedContentParams = {
      cartLocale: this.cart.locale,
      userLocale: this.state.userLocale,
      storeDomain: this.state.storeDomain,
      lineItems: [],
    };

    this.cart.lineItems.map((item) => {
      localizedContentParams.lineItems.push({
        _id: item._id,
        productPath: item.metadata.productInfo.productPath,
      });
    });

    DataService.localizedContent(
      this.urls.istApiUrl,
      localizedContentParams,
    ).then(
      (localizedContentRes) => {
        this.cart.locale = localizedContentParams.userLocale;
        this.language = this.cart.locale.split('-')[0];

        this.cart.lineItems.map((item) => {
          const localizedContentItem = _.find(
            localizedContentRes.localizedContent,
            {_id: item._id},
          );

          if (localizedContentItem) {
            item.productName = localizedContentItem.productName;
            item.metadata.productInfo.shortDescription
              = localizedContentItem.shortDescription;
          }
        });

        DataService.updateCart(this.urls.istApiUrl, this.cart);
        return this.renderProducts();
      },
      (error) => {
        this.language = this.cart.locale.split('-')[0];
        return this.renderProducts();
      },
    );
  }

  goToCustomerNumberPage() {
    window.location.href = this.urls.customerNumberUrl;
  }

  formatStorePrice(price, formattedLocale, currency) {
    return _formatStorePrice(price, formattedLocale, currency);
  }

  formatStoreDate(displayDate, formattedLocale) {
    const displayDateFormatted = new Date(displayDate);
    const dateOptions = {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      timeZone: 'UTC',
    };
    const locale
      = formattedLocale.split('_')[0] + '-' + formattedLocale.split('_')[1];

    return displayDateFormatted.toLocaleDateString(locale, dateOptions);
  }

  addQueryString(url, queryString) {
    if (queryString) {
      var isQuestionMarkPresent = url && url.indexOf('?') !== -1,
        separator = isQuestionMarkPresent ? '&' : '?';
      url += separator + queryString;
    }

    return url;
  }

  setEnvUrls() {
    this.urls['cartUrl'] = window.storeVariables.cartUrl;
    this.urls['customerNumberUrl'] = window.storeVariables.customerNumberUrl;
    this.urls['istApiUrl'] = window.storeVariables.eCommUrl;
    this.urls['lookupAPIUrl'] = window.storeVariables.lookupUrl;
    this.urls['accountsUrl'] = window.storeVariables.accountsUrl;
    this.urls['checkoutUrl'] = window.storeVariables.checkoutUrl;
    this.urls['contactUsPageUrl']
      = window.storeVariables.storeHomepageUrl || this.urls['contactUsPageUrl'];
    this.urls['storeHomePageUrl']
      = window.storeVariables.contactUsUrl || this.urls['storeHomePageUrl'];
  }

  setCookie(cookieName, cookieValue, cookieDomain, expires) {
    const domain = cookieDomain || getRootDomain(location.host);
    Cookies.set(cookieName, cookieValue, {
      expires: expires || 2000,
      path: '/',
      domain: domain,
    });
  }

  getCookie(cookieName) {
    return Cookies.get(cookieName);
  }

  getJSONCookie(cookieName) {
    try {
      return JSON.parse(Cookies.get(cookieName));
    } catch (e) {
      return null;
    }
  }

  removeCookie(cookieName) {
    const domain = getRootDomain(location.host);
    Cookies.remove(cookieName, {domain: domain, path: '/'});
  }

  updateskuListCookie(sku) {
    const cookieName = 'cartSKUList';
    const cookieExpiry = {
      expires: 7,
      path: '/',
    };
    const skuListCookieValue = this.getCookie(cookieName);
    let skuList = skuListCookieValue ? JSON.parse(skuListCookieValue) : [];
    if (skuList.length > 0 && skuList.includes(sku)) {
      skuList = skuList.filter((e) => e !== sku);
      Cookies.set(cookieName, JSON.stringify(skuList), cookieExpiry);
    }
  }

  handlePrintCartClick() {
    window.print();
  }

  addPrintCartStyle() {
    let bodyTag = document.querySelector('body');
    let navBar = document.querySelector('.gnav_top-nav-branding-section');

    if (this.distPrintCart?.isPrintCart && navBar) {
      bodyTag.classList.add('print-cart-style');
      let contactSection = document.createElement('div');
      contactSection.classList.add('cart-contact-printView');

      let address = document.createElement('div');
      let fullAddr = this.distPrintCart.fullAddr
        ? this.distPrintCart.fullAddr
        : '';
      address.textContent = fullAddr;

      let phone = document.createElement('div');
      phone.textContent = this.distPrintCart.phoneNumber;

      contactSection.appendChild(address);
      contactSection.appendChild(phone);
      navBar.appendChild(contactSection);
    }
  }
}

MapTo('esri-sites/components/content/cart')(Cart);
export default Cart;
